var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g2, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g3, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _circle, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _g4, _g5, _path113, _path114, _path115, _path116, _path117, _path118, _rect2, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g6, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingcar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 819.209,
    height: 439.409,
    viewBox: "0 0 819.209 439.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 2.368,
    gradientTransform: "translate(0.394 -20.195) scale(0.211 0.211)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#072372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072372",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.425,
    y1: 1.608,
    x2: 0.548,
    y2: -0.165,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.425,
    y1: 1.608,
    x2: 0.548,
    y2: -0.165,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#456afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456afc",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.472,
    y1: 0.578,
    x2: -0.192,
    y2: 0.361,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faab83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.505,
    y1: 0.497,
    x2: -0.181,
    y2: 0.397,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.293,
    y1: 0.165,
    x2: 1.006,
    y2: 0.925,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e58905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.059,
    y1: 0.221,
    x2: 1.003,
    y2: 0.985,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.628,
    y1: 0.925,
    x2: 0.769,
    y2: 0.234,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.612,
    y1: 0.907,
    x2: 0.757,
    y2: 0.228,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 9.396,
    y1: 0.16,
    x2: 10.14,
    y2: 0.839,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.498,
    y1: 0.235,
    x2: 1.487,
    y2: 0.936,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.796,
    y1: -0.063,
    x2: 1.596,
    y2: 0.632,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1343a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.88,
    y1: -0.263,
    x2: 1.342,
    y2: 0.827,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.499,
    y1: 0.138,
    x2: 0.981,
    y2: 0.95,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.465,
    y1: 0.046,
    x2: 0.966,
    y2: 0.988,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.482,
    y1: 0.106,
    x2: 0.955,
    y2: 1.827,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.442,
    y1: 1.15,
    x2: 0.516,
    y2: 0.216,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#456afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dadfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.445,
    y1: 1.142,
    x2: 0.502,
    y2: 0.208,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1343a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dadfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.664,
    y1: 0.813,
    x2: 0.272,
    y2: -0.022,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.493,
    y1: 1.076,
    x2: 0.522,
    y2: 0.156,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.687,
    y1: 3.885,
    x2: 1.652,
    y2: 2.934,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1.709,
    y1: 3.645,
    x2: 1.679,
    y2: 2.695,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.345,
    y1: 1.448,
    x2: 0.501,
    y2: 0.528,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.445,
    y1: 1.883,
    x2: 0.49,
    y2: 0.781,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.848,
    y1: 1.171,
    x2: 0.176,
    y2: 0.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1.182,
    y1: 0.405,
    x2: -0.202,
    y2: 0.452,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.636,
    y1: 0.422,
    x2: -0.204,
    y2: 0.789,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1.429,
    y1: 0.569,
    x2: -0.955,
    y2: 0.422,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -2.561,
    y1: -0.269,
    x2: -2.463,
    y2: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#456afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -3.027,
    y1: 1.414,
    x2: -3.16,
    y2: 0.202,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -1.399,
    y1: -0.269,
    x2: -1.302,
    y2: 1.284,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1.516,
    y1: 1.414,
    x2: -1.649,
    y2: 0.202,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.976,
    y1: 0.97,
    x2: -0.122,
    y2: 0.144,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0.851,
    y1: 0.54,
    x2: -0.147,
    y2: 0.319,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1.37,
    y1: -0.152,
    x2: -0.021,
    y2: 0.079,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 2.324,
    y1: 0.116,
    x2: 0.688,
    y2: 0.132,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1.054,
    y1: 0.476,
    x2: -0.408,
    y2: 0.539,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1.07,
    y1: 0.484,
    x2: -0.433,
    y2: 0.526,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1.098,
    y1: 0.254,
    x2: -0.293,
    y2: 0.394,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1.017,
    y1: 0.423,
    x2: -0.349,
    y2: 0.558,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1.028,
    y1: 0.384,
    x2: -0.358,
    y2: 0.689,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1.029,
    y1: 0.472,
    x2: -0.384,
    y2: 0.535,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1.112,
    y1: 0.493,
    x2: -0.502,
    y2: 0.511,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1.112,
    y1: 0.493,
    x2: -0.502,
    y2: 0.511,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1.112,
    y1: 0.493,
    x2: -0.502,
    y2: 0.511,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0.12,
    y1: -0.305,
    x2: 0.975,
    y2: 1.014,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456afc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 0.5,
    y1: -0.063,
    x2: 0.5,
    y2: 1.036,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.194,
    y1: 0.47,
    x2: 0.831,
    y2: 0.533,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.032,
    y1: 0.341,
    x2: 0.889,
    y2: 0.604,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20f53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 0.922,
    y1: 0.161,
    x2: -0.344,
    y2: 1.515,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 0.938,
    y1: 0.363,
    x2: -0.328,
    y2: 1.72,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 0.266,
    y1: 0.914,
    x2: 0.846,
    y2: -0.262,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cc4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b80ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456afc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -0.081,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1.408,
    y1: -0.781,
    x2: 0.131,
    y2: 0.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M323.3,147.186c24.66-8.109,177.645-6.2,177.645-6.2s-20.74,53.954-28.69,62.491-39.749,9.562-50.465,11.269-175.507-.6-183.542,0-12.209-6.434-12.209-6.434l18.085-3.47S297.7,155.605,323.3,147.186Z",
    transform: "translate(-226.041 -140.794)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 0.944,
    y1: 0.234,
    x2: 0.619,
    y2: 0.701,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0.953,
    y1: 0.218,
    x2: 0.628,
    y2: 0.685,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 2.79,
    y1: 1.368,
    x2: 2.446,
    y2: 1.863,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1.218,
    y1: -0.249,
    x2: -0.63,
    y2: 1.784,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 0.07,
    y1: -0.173,
    x2: 0.572,
    y2: 0.635,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 0.989,
    y1: 0,
    x2: -0.047,
    y2: 1.207,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1.03,
    y1: -0.153,
    x2: -2.332,
    y2: 3.324,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 0.952,
    y1: -0.083,
    x2: -1.654,
    y2: 3.059,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 0.5,
    y1: 1.418,
    x2: 0.5,
    y2: 0.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4d0e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 0.035,
    y1: 0.2,
    x2: 1.185,
    y2: 0.962,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -0.555,
    y1: 0.2,
    x2: 1.298,
    y2: 0.962,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M139.419,257.735l-10.972,37.979,10.972,17.341,106.462,8.2,17.283-11.611s8.987-35.67,26.27-45.836C289.433,263.805,158.084,272.078,139.419,257.735Z",
    transform: "translate(-128.447 -257.735)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -0.006,
    y1: 0.527,
    x2: 0.995,
    y2: 0.527,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -0.005,
    y1: 0.53,
    x2: 0.996,
    y2: 0.53,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -0.003,
    y1: 0.532,
    x2: 0.997,
    y2: 0.532,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -0.002,
    y1: 0.535,
    x2: 0.999,
    y2: 0.535,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -0.006,
    y1: 0.527,
    x2: 0.995,
    y2: 0.527,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -0.005,
    y1: 0.53,
    x2: 0.996,
    y2: 0.53,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -0.004,
    y1: 0.532,
    x2: 0.997,
    y2: 0.532,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -0.002,
    y1: 0.535,
    x2: 0.998,
    y2: 0.535,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -0.001,
    y1: 0.488,
    x2: 1,
    y2: 0.488,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -0.001,
    y1: 0.49,
    x2: 1,
    y2: 0.49,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 0.016,
    y1: 0.494,
    x2: 1.057,
    y2: 0.494,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 0,
    y1: 0.5,
    x2: 1.181,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 0.012,
    y1: 0.499,
    x2: 1.054,
    y2: 0.499,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 0.943,
    y1: 0.207,
    x2: 0.289,
    y2: 0.649,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 0.387,
    y1: -0.286,
    x2: 0.494,
    y2: 0.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 0.531,
    y1: 0.951,
    x2: 0.505,
    y2: 0.567,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 0.992,
    y1: -0.195,
    x2: 0.058,
    y2: 1.143,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -0.13,
    y1: 1.63,
    x2: 1.217,
    y2: -0.547,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 0.218,
    y1: 0.936,
    x2: 0.68,
    y2: 0.221,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 0.433,
    y1: 1.073,
    x2: 0.526,
    y2: 0.317,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 0.463,
    y1: 1.045,
    x2: 0.532,
    y2: 0.301,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 2.368,
    gradientTransform: "translate(0.394 -6.643) scale(0.211 0.211)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 2.368,
    gradientTransform: "translate(0.394 -6.475) scale(0.211 0.211)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 0.874,
    y1: 1.142,
    x2: 0.249,
    y2: 0.019,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 0.892,
    y1: 1.093,
    x2: 0.395,
    y2: 0.025,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1.923,
    y1: 0.568,
    x2: 2.527,
    y2: 1.385,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 0.579,
    y1: 0.648,
    x2: 0.071,
    y2: 0.219,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 0.191,
    y1: 0.244,
    x2: 1.001,
    y2: 1.015,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -0.028,
    y1: 0.302,
    x2: 1.109,
    y2: 1.065,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 0.439,
    y1: 1.153,
    x2: 0.58,
    y2: 0.462,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 0.411,
    y1: 1.138,
    x2: 0.557,
    y2: 0.458,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 0.308,
    y1: 0.37,
    x2: 0.774,
    y2: 1.39,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 1.865,
    y1: 0.291,
    x2: 2.61,
    y2: 0.97,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 0.341,
    y1: 0.374,
    x2: 1.33,
    y2: 1.075,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 0.474,
    y1: 0.286,
    x2: 1.274,
    y2: 0.98,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 0.558,
    y1: 0.476,
    x2: 1.194,
    y2: 1.655,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 0.386,
    y1: 0.374,
    x2: 0.869,
    y2: 1.186,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 0.34,
    y1: 0.339,
    x2: 0.841,
    y2: 1.281,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 0.408,
    y1: 0.487,
    x2: 0.85,
    y2: 1.977,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 0.485,
    y1: 0.961,
    x2: 0.697,
    y2: 0.076,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 0.407,
    y1: 0.963,
    x2: 0.669,
    y2: 0.076,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 0.386,
    y1: 1.276,
    x2: 0.415,
    y2: 0.355,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 6.164,
    y1: -0.374,
    x2: 6.259,
    y2: 1.214,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 0.444,
    y1: -0.438,
    x2: 0.544,
    y2: 1.225,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 8.637,
    y1: -0.074,
    x2: 8.736,
    y2: 1.44,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: -0.12,
    y1: -0.128,
    x2: -0.015,
    y2: 1.458,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: -0.052,
    y1: 2.04,
    x2: 0.632,
    y2: -0.059,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 0.476,
    y1: 0.446,
    x2: -0.012,
    y2: 0.122,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 0.577,
    y1: 1.28,
    x2: 0.419,
    y2: 0.179,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 1.899,
    y1: 2.549,
    x2: 1.738,
    y2: 1.634,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 0.739,
    y1: 1.082,
    x2: 0.197,
    y2: 0.059,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 2.014,
    y1: 1.055,
    x2: -0.864,
    y2: 0.082,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 1.197,
    y1: 1.076,
    x2: 0.331,
    y2: 0.033,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: -0.285,
    y1: 1.137,
    x2: 0.962,
    y2: 0.125,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: -3.132,
    y1: 0.678,
    x2: 2.64,
    y2: 0.395,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: -0.173,
    y1: 1.777,
    x2: 0.896,
    y2: -0.252,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: -0.173,
    y1: 1.777,
    x2: 0.896,
    y2: -0.252,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -0.975,
    y1: 0.727,
    x2: 1.369,
    y2: 0.366,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 0.535,
    y1: 1.101,
    x2: 0.457,
    y2: -0.074,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 0.076,
    y1: 1.132,
    x2: 0.692,
    y2: 0.463,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -0.297,
    y1: 1.018,
    x2: 0.655,
    y2: 0.457,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 0.5,
    y1: 0.875,
    x2: 0.5,
    y2: 0.147,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 4.707,
    y1: 3.663,
    x2: 5.71,
    y2: 3.663,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 0.514,
    y1: 1.182,
    x2: 0.497,
    y2: 0.306,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 0.504,
    y1: 1.152,
    x2: 0.497,
    y2: 0.339,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 0.502,
    y1: 1.152,
    x2: 0.494,
    y2: 0.339,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -14.454,
    y1: 0.778,
    x2: -14.301,
    y2: 0.095,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -15.315,
    y1: 0.766,
    x2: -15.158,
    y2: 0.087,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 1.679,
    y1: 0.076,
    x2: 2.424,
    y2: 0.755,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -11.206,
    y1: 0.153,
    x2: -10.217,
    y2: 0.853,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 0.37,
    y1: 0.232,
    x2: 0.935,
    y2: 1.069,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 0.505,
    y1: 1.152,
    x2: 0.495,
    y2: 0.339,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 0.773,
    y1: 0.246,
    x2: -0.321,
    y2: 1.402,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 1.155,
    y1: 0.245,
    x2: -0.744,
    y2: 1.326,
    xlinkHref: "#linear-gradient-11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(-873.066 -296.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(872.487 222.779)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 71.825,
    cy: 15.163,
    rx: 71.825,
    ry: 15.163,
    transform: "translate(36.719 384.661)",
    opacity: 0.7,
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(515.875 387.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M593.028,360.457c6.351,14.488-40.4,8.444-45.656,10.341s29.019,4.989,25.676,12.091-106.893,5.792-117.522-5.661,78.639-10.722,76.7-16.771-30.183-4.339-25.583-8.157S587.447,347.727,593.028,360.457Z",
    transform: "translate(-454.646 -349.845)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M604.874,360.457c6.35,14.488-40.4,8.444-45.656,10.341s29.021,4.989,25.676,12.091S478,388.681,467.372,377.228s78.636-10.722,76.7-16.771-30.181-4.339-25.583-8.157S599.295,347.727,604.874,360.457Z",
    transform: "translate(-453.049 -349.845)",
    opacity: 0.4,
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(306.908 73.721)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M344.781,124.123,361.7,127.13c15.461.5,34.794,7.572,34.794,7.572l-30.884,9.469-23.049-5.063Z",
    transform: "translate(-260.794 -66.924)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M353.752,125.717l-8.971-1.594-2.219,14.986,23.049,5.063.957-.293C357.985,141.216,350.181,135.263,353.752,125.717Z",
    transform: "translate(-260.794 -66.924)",
    opacity: 0.4,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M360.848,125.079s-21.178-6.671-27.592-7.555v0a11.45,11.45,0,0,0-3.438-.362l-2.636.124-17.043-2.755c-3.731,2.2-14.929,2.893-18.184,9.047s-8.8,24.261-8.8,24.261c4.528,5.992,17.359,6.278,17.359,6.278l-2.345,37.012c29.612,11.044,47.4-1.563,47.4-1.563s-.962-29.638-2.477-49.1l12.269,2.081S350.113,126.544,360.848,125.079Z",
    transform: "translate(-268.805 -68.218)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M341.854,148.345l-.5-8.131,12.269,2.081-.575-2.169a45.206,45.206,0,0,1-19.655-10.85s1.776,12.687,2.53,17.721c-15.128-4.437-28.478-16.19-33.738-30.6-1.441.41-2.961.86-4.432,1.411,4.107,11.893,2.684,24.844-1.631,35.865,1.6.174,2.652.2,2.652.2l-2.345,37.012c29.612,11.044,47.4-1.563,47.4-1.563s-.726-22.334-1.909-40.961Z",
    transform: "translate(-267.058 -67.966)",
    opacity: 0.4,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M308,101.985c1.408,4.072-1.063,14.511-1.063,14.511,5.25,6.376,13.545,5.977,17.043,2.755-.611-2.39,1.716-11.433,1.716-11.433l-15.163-7.842Z",
    transform: "translate(-265.599 -70.181)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M325.566,107.819,310.4,99.977l-2.533,2.008a12.261,12.261,0,0,1,.426,4.048c2.91,5.755,5.464,13.061,11.1,15.291a9.018,9.018,0,0,0,4.45-2.072C323.239,116.861,325.566,107.819,325.566,107.819Z",
    transform: "translate(-265.473 -70.181)",
    opacity: 0.4,
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(35.683)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M304.252,97.092c1.1-1.461,3.214-.612,4.034-.047-.548-3.6-.882-6.163-.882-6.163s.259-10.553,12.756-11.3c11.581-.69,13.71,4.033,14.214,12.161,0,0-.229,14.8-.769,16.878s-5.421,7.988-9.689,8.254-11.779-4.443-13.051-6.975a14.741,14.741,0,0,1-.9-3.171C306.044,107.061,302.359,99.607,304.252,97.092Z",
    transform: "translate(-301.713 -72.94)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M313.145,81.284a11.907,11.907,0,0,0-5.74,9.36s.334,2.568.882,6.163c-.82-.565-2.935-1.414-4.034.047-1.893,2.515,1.792,9.969,5.716,9.639a14.762,14.762,0,0,0,.9,3.171c1.272,2.532,8.784,7.239,13.051,6.975a6.671,6.671,0,0,0,2.358-.651C313.511,118.856,307.932,93.578,313.145,81.284Z",
    transform: "translate(-301.713 -72.701)",
    opacity: 0.3,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M314.208,89.14c.674,5.333-3.821,10.3-3.849,11.675s-2.01-4.768-2.01-4.768-2.775-1.239-4.034.047c0,0-2.248-4.88-.138-8.017S314.208,89.14,314.208,89.14Z",
    transform: "translate(-301.776 -71.942)",
    fill: "url(#linear-gradient-11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M319.111,86.871c5.176,6.006,14.723.659,11.683-2.174S319.111,86.871,319.111,86.871Z",
    transform: "translate(-299.64 -72.358)",
    fill: "url(#linear-gradient-12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M333.426,84.419s-3.366-8.16-4.173-8.872-8.516-2.063-12.922-1.79-10.979,5.562-13.429,8.763.615,12.009.615,12.009l2.752-1.086Z",
    transform: "translate(-301.954 -73.721)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M307.918,77.27a27.9,27.9,0,0,0-5.015,4.772c-2.449,3.2.615,12.009.615,12.009l2.752-1.086,24.076-8C321.674,85.137,312.681,83.543,307.918,77.27Z",
    transform: "translate(-301.954 -73.243)",
    opacity: 0.3,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M343.574,92.338c-8.431-8.235-21.966,2.161-29,1.234a64.383,64.383,0,0,0-9.743-.8s3.292-7.344,13.459-9.955,14.747.515,14.747.515Z",
    transform: "translate(-301.566 -72.635)",
    fill: "url(#linear-gradient-15)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M299.467,116.753c6.68,16.09,7.616,45.162-3.97,48.8l3.439,19.918s-5.5,23.479-5.291,38.485c5.3,1.593,20.506.454,32.5-.114s16.39-1.913,23.009-4.786c-.822-13.228-3.719-36.474-3.719-36.474l-.166-26.079c-9.734-4.72-13.5-39.625-13.5-39.625l-4.64-.422c2.425,7.614,3.479,24.343,3.479,24.343-11.487,3.642-19.677,1.209-19.677,1.209-.395-10.757-6.128-26.948-6.128-26.948Z",
    transform: "translate(-267.392 -68.147)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M306.643,189.264c-5.846-14.475,1.633-36.229-2.33-51.936.511,12.007-1.959,23.067-8.816,25.22l3.439,19.918s-5.5,23.479-5.291,38.485c5.3,1.593,20.506.454,32.5-.113s16.39-1.913,23.009-4.786c-.345-5.561-1.058-12.89-1.767-19.521C331.053,210.819,311.075,203.245,306.643,189.264Z",
    transform: "translate(-267.392 -65.144)",
    opacity: 0.25,
    fill: "url(#linear-gradient-17)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M298.187,160.65l3.39-10.66c-5.719-.6-11.047-1.377-15.583-5.063a116.746,116.746,0,0,0-4.788,19.819c-1.088,7.479-10.695,47.127-10.695,47.127l8.488-.629C287.6,192.977,298.187,160.65,298.187,160.65Z",
    transform: "translate(-270.511 -64.119)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M306.809,163.6s23.519.847,31.685-1.968c0,0,1.271,21.116-15.008,24.433S306.809,163.6,306.809,163.6Z",
    transform: "translate(-265.616 -61.865)",
    opacity: 0.35,
    fill: "url(#linear-gradient-19)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(422.932 129.223)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M420.276,138.606c1.083-1.422.8-8.278.8-8.278s-25.475-8.157-27.592-7.681-20.74,15.639-20.74,15.639l.506,8.005,21.12-7.219Z",
    transform: "translate(-372.747 -122.627)",
    fill: "url(#linear-gradient-20)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M404.447,140.563c2.162-2.4,15.769-3.033,15.769-3.033l-27.074-6.918s-6.128,10.345-8.5,10.394-11.45,4.21-11.45,4.21l17.17,5.951Z",
    transform: "translate(-372.687 -121.551)",
    fill: "url(#linear-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M404.447,140.563c2.162-2.4,15.769-3.033,15.769-3.033l-27.074-6.918s-6.128,10.345-8.5,10.394-11.45,4.21-11.45,4.21l17.17,5.951Z",
    transform: "translate(-372.687 -121.551)",
    opacity: 0.5,
    fill: "url(#linear-gradient-21)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(139.857 302.384)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M177.125,373.223a72.4,72.4,0,0,0-47.008,25.961c-14.683,18.142-7.7,28.863,41.679,16.627,68.705-17.023,95.374-18.769,126.819,9.493s70.059-9.755,117.746-15.869,91.859,23.052,127.346,6.376,31.729-65.218,80.191-69.734,104.414-26.813,40.32-54.918-98.635,18.738-187.61,3.166-149.194,24.266-198.334,50.4C245.642,362.08,202.458,369.916,177.125,373.223Z",
    transform: "translate(-123.31 -274.3)",
    fill: "url(#linear-gradient-23)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M186.251,368.566a72.4,72.4,0,0,0-47.008,25.961c-14.683,18.141-7.7,28.86,41.679,16.627,68.705-17.024,95.374-18.769,126.819,9.493s70.058-9.756,117.746-15.869,91.86,23.05,127.347,6.376,31.729-65.22,80.189-69.733,104.416-26.814,40.323-54.92-98.637,18.739-187.612,3.169S336.54,313.934,287.4,340.068C254.768,357.423,211.584,365.259,186.251,368.566Z",
    transform: "translate(-122.08 -274.928)",
    fill: "url(#linear-gradient-24)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M147.728,400.813l280.433,16.977a41.01,41.01,0,0,0,16.41-2.366L696.5,324.347a4.132,4.132,0,0,0-.756-7.968L436.61,275.212,146.484,393.245A3.933,3.933,0,0,0,147.728,400.813Z",
    transform: "translate(-120.516 -275.212)",
    fill: "#072372",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(0.611 110.4)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 51.881,
    transform: "translate(191.768 90.26)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 2.969
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M214.317,183.665v6.271l13.059,1.966V181.7Z",
    transform: "translate(28.208 -95.839)",
    fill: "url(#linear-gradient-25)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M115.777,173.788s6.856,24.551,7.7,25.391c6.5-.42,33.159,2.543,33.159,2.543v9.024c-23.293,3.147-41.515,1.92-47.429-6.741s-9.233-27.49-9.233-27.49Z",
    transform: "translate(12.788 -96.906)",
    fill: "url(#linear-gradient-26)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M151.113,190.236a20.782,20.782,0,0,1-19.195,14.551",
    transform: "translate(17.096 -94.688)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.98
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M143.963,189.718s-8.74,8.2-9.843,17.253l-8.64-.457c1.3-14.489,16.2-25.132,16.2-25.132Z",
    transform: "translate(16.228 -95.882)",
    fill: "url(#linear-gradient-27)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M102.512,153.383c7.929,1.753,13.806,12.665,15.694,24.626-2.308,3.357-7.846,2.727-7.846,2.727L97.011,160.442Z",
    transform: "translate(12.389 -99.657)",
    fill: "url(#linear-gradient-28)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M117.106,169.676c-.944-4.2-13.035-18.324-13.035-18.324l-17.847-3.08c-3.5,4.477-16.367,5.036-17.486,15.948s4.477,26.86,4.477,26.86c1.345-1.668,4.244-2.838,7.3-3.649a81.816,81.816,0,0,1,1.23,10.154c.84,15.738-5.666,30.847-5.666,30.847s29.588,13.85,42.675,3.777C118.757,232.207,118.05,173.872,117.106,169.676Z",
    transform: "translate(8.556 -100.347)",
    fill: "url(#linear-gradient-28)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M110.732,120.26c4.955,3,2.262,9.411,2.582,11.225s2.906,4.677,2.373,5.53-2.657.818-2.657,2.312-.415,8.019-4.042,9.619a11.467,11.467,0,0,1-6.8.813s-1.173,4.055-.64,6.51,3.77,5.868,1.921,8.287-13.659-6.4-15.508-8.393-2.732-3.175-2.732-3.175a78.3,78.3,0,0,0,3.05-12.043c1.2-6.951-7.148-19.5,5.513-24.192S106.054,117.43,110.732,120.26Z",
    transform: "translate(10.8 -104.847)",
    fill: "url(#linear-gradient-30)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M106.3,118.914c4.268,2.987,9.709,3.472,9.709,2.365s-3.272-14.921-19.277-14.494S78.976,118.252,78.976,127c0,6.764,2.984,8.81,5.107,13.421.481,1.047,3.915,5.818,4.423,4.785,2.067-4.2,2.362-9.388,4.107-12.018a6.379,6.379,0,0,1,.6-.794c2.719-2.905,6.83,1.708,6.936,4.375-.533-4.268,3.415-5.65,3.735-10.028A19.446,19.446,0,0,1,106.3,118.914Z",
    transform: "translate(9.957 -105.943)",
    fill: "url(#linear-gradient-25)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M112.137,119s7.463,2.447,9.747,5.577c.916,1.256-19.669-2.141-19.669-2.141Z",
    transform: "translate(13.091 -104.294)",
    fill: "url(#linear-gradient-32)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M116.655,121.191s-2.742-8.8-5.928-10.891-11.784-5.044-18.6-4.065c-5.346.769-12.487,5.6-13.579,12.058a56.875,56.875,0,0,0-.657,12.662c17.615,1.238,27.621-6.767,27.621-6.767Z",
    transform: "translate(9.796 -106.042)",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M89.219,106.885c-4.738,1.74-9.771,5.96-10.673,11.294a56.875,56.875,0,0,0-.657,12.662c17.615,1.238,27.621-6.767,27.621-6.767l.844-.228C99.462,120.238,90.97,114.815,89.219,106.885Z",
    transform: "translate(9.796 -105.928)",
    opacity: 0.3,
    fill: "url(#linear-gradient-28)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M95.013,137.076c-3.086.548-4.531-4.738-4.129-6.706l-.813,1.387S90.53,138.357,95.013,137.076Z",
    transform: "translate(11.453 -102.761)",
    opacity: 0.4,
    fill: "url(#linear-gradient-35)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M100.609,146.287a9.861,9.861,0,0,1-3.683-5.647l2.953,9.67Z",
    transform: "translate(12.378 -101.376)",
    opacity: 0.6,
    fill: "url(#linear-gradient-36)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M122.6,235.878s-3.094-44.129-3.031-51.39-2.961-18.566-5.266-22.813-7.657-10.209-7.657-10.209l-2.955-.116s6.452,10.007,7.894,17.185c0,0-4.825,1.754-15.97,2.074C94.039,160.4,85.1,148.271,85.1,148.271l-3.19,1.979c16.273,31.048,11.41,45.309-3.388,52.7a49.649,49.649,0,0,0-.973,9.528c.1,4.384-5.064,13.6-5.956,25.724h0c-.7,7.991,1.177,16.058,1.3,25.418.21,15.528,2.811,42.178,1.834,50.571a292.369,292.369,0,0,0-1.491,33.433h21.55s2.342-27.227,5.2-49.227c-.851,6.815-2.469,29.494.665,48.417l23.265-1.834v-79.34C123.924,257.207,123.125,244.064,122.6,235.878Z",
    transform: "translate(8.941 -100.347)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M86.7,320.436c-6.381-30.63-10-59.345-7.445-88.7a177.538,177.538,0,0,1,9.9-43.446c-2.342,3.962-6,6.946-10.629,9.257a49.645,49.645,0,0,0-.973,9.527c.1,4.385-5.064,13.6-5.956,25.725-.7,7.991,1.177,16.058,1.3,25.419.21,15.528,2.811,42.178,1.834,50.571a292.369,292.369,0,0,0-1.491,33.433h21.55s.533-6.2,1.4-15.061C91.3,326.568,87.349,324.328,86.7,320.436Z",
    transform: "translate(8.941 -94.95)",
    opacity: 0.4,
    fill: "url(#linear-gradient-37)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M87.158,181.961h1.387l-2.392-14.427a23.873,23.873,0,0,1,3.9,10.367,21.7,21.7,0,0,1-1.417,10.132Z",
    transform: "translate(10.925 -97.749)",
    opacity: 0.6,
    fill: "url(#linear-gradient-39)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M96.741,285.749c2.659-13.4,3.822-43.711,3.822-43.711s-.525,25.632-.951,40.1,4.573,42.116,19.729,42.967v9.306l-21.936-.239s-1.832-18.433-1.833-23.32S96.741,285.749,96.741,285.749Z",
    transform: "translate(12.195 -87.702)",
    opacity: 0.4,
    fill: "url(#linear-gradient-37)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(105.645 238.45)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M122.942,318.956s-18.229,2.749-26.857-2.8c0,0,.34,21.07.015,27.773s-5.493,16.464.437,22.7c4.938,5.191,21.619,3.492,28.867,3.223s17.732-4.234,15.025-13.7-20.54-1.559-21.271-9.839S122.942,318.956,122.942,318.956Z",
    transform: "translate(-93.702 -316.157)",
    fill: "url(#linear-gradient-41)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M96.1,343.93c.326-6.7-.015-27.773-.015-27.773a21.642,21.642,0,0,0,5.394,2.362c-5.914,21.664,7.577,47.777,28.462,50.726a24.847,24.847,0,0,1-4.537.608c-7.248.269-23.93,1.968-28.867-3.224C90.606,360.395,95.772,350.635,96.1,343.93Z",
    transform: "translate(-93.702 -316.157)",
    opacity: 0.2,
    fill: "url(#linear-gradient-42)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(78.266 238.45)"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M98.817,318.956s-18.229,2.749-26.857-2.8c0,0,.34,21.07.014,27.773s-5.492,16.464.438,22.7c4.937,5.191,21.619,3.492,28.867,3.223s17.732-4.234,15.025-13.7-20.54-1.559-21.271-9.839S98.817,318.956,98.817,318.956Z",
    transform: "translate(-69.577 -316.157)",
    fill: "url(#linear-gradient-43)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M71.973,343.93c.327-6.7-.014-27.773-.014-27.773a21.642,21.642,0,0,0,5.394,2.362c-5.914,21.664,7.577,47.777,28.462,50.726a24.847,24.847,0,0,1-4.537.608c-7.248.269-23.931,1.968-28.867-3.224C66.481,360.395,71.646,350.635,71.973,343.93Z",
    transform: "translate(-69.577 -316.157)",
    opacity: 0.2,
    fill: "url(#linear-gradient-44)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M114.2,200.147H90.725s-3.121,25.312,11.737,25.312S114.2,200.147,114.2,200.147Z",
    transform: "translate(11.505 -93.351)",
    opacity: 0.4,
    fill: "url(#linear-gradient-37)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M73.447,185.635S79.9,208.21,85.105,211.39s40.471-9.035,42.423-9.468,11.6,3.36,13.876,3.36a2.847,2.847,0,0,0,2.818-1.951,3.8,3.8,0,0,0,3.144-3.795s2.169-.541,1.843-3.468c0,0,2.06-1.3.868-4.227s-10.841-2.278-13.226-2.711-7.7,3.469-8.456,3.795-32.3,1.987-34.472,3.288c-1.591-2.457-3.336-12.283-4.539-16.42C79.17,180.16,73.447,185.635,73.447,185.635Z",
    transform: "translate(9.211 -96.096)",
    fill: "url(#linear-gradient-46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M90.083,182.511c-.247-1.038-.482-1.973-.7-2.719-10.214.368-15.937,5.843-15.937,5.843a152.846,152.846,0,0,0,6.382,17.788C79.691,195.139,82.9,186.668,90.083,182.511Z",
    transform: "translate(9.211 -96.096)",
    opacity: 0.3,
    fill: "url(#linear-gradient-47)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M133.7,206.538l-7.949-.421a1.308,1.308,0,0,1-1.234-1.371h0a1.308,1.308,0,0,1,1.372-1.234l7.949.42a1.308,1.308,0,0,1,1.234,1.371h0A1.31,1.31,0,0,1,133.7,206.538Z",
    transform: "translate(16.098 -92.898)",
    fill: "url(#linear-gradient-48)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    d: "M2.172,0H4.06A2.173,2.173,0,0,1,6.233,2.173V27.23A2.172,2.172,0,0,1,4.061,29.4H2.173A2.173,2.173,0,0,1,0,27.229V2.172A2.172,2.172,0,0,1,2.172,0Z",
    transform: "translate(173.047 90.559) rotate(10.191)",
    fill: "url(#linear-gradient-49)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 7.582,
    height: 8.331,
    transform: "translate(186.924 86.094)",
    fill: "url(#linear-gradient-50)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 4.844,
    height: 8.331,
    transform: "translate(186.924 86.094)",
    opacity: 0.4,
    fill: "url(#linear-gradient-51)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M168.9,192.846l-25.761.836a2.305,2.305,0,0,1-2.174-2.417l-2.6-11.181a2.3,2.3,0,0,1,2.418-2.174l28.829,1.523a2.306,2.306,0,0,1,2.176,2.418l-.466,8.819A2.307,2.307,0,0,1,168.9,192.846Z",
    transform: "translate(17.966 -96.35)",
    fill: "url(#linear-gradient-52)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M143.571,178.057l-2.787-.146a2.3,2.3,0,0,0-2.418,2.174l2.6,11.181a2.305,2.305,0,0,0,2.174,2.417l25.761-.838a2.3,2.3,0,0,0,2.227-1.39C161.163,189.53,148.731,186.889,143.571,178.057Z",
    transform: "translate(17.966 -96.35)",
    opacity: 0.3,
    fill: "url(#linear-gradient-53)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M141.446,179.157l27.882,1.4a1,1,0,0,1,.946,1v3.075a1,1,0,0,1-1,1H142.244a1,1,0,0,1-.978-.81l-.849-4.477A1,1,0,0,1,141.446,179.157Z",
    transform: "translate(18.24 -96.182)",
    opacity: 0.4,
    fill: "url(#linear-gradient-54)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M245.664,188.256H215.9c-5.055,0-16.521,13.522-23.519,9.523s-13.3-1.792-16.357,3.972c-3.89,7.336-3.09,14.5-3.423,41.334s-30.279,66.541-100.051,131c-20.535,18.971-36.856,30.445-11.916,32.786,50.716,4.757,78.794-13.92,83.558,2.187,5.591,18.907-143.58,9.287-143.58,9.287",
    transform: "translate(-0.611 -94.955)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M148.193,198.269c-1.025-1.958.7-5.595,3.637-5.176s8.533-.279,9.652,1.4,0,3.777,0,3.777,1.555,2.239.5,3.918c0,0,.622,2.658-1.478,3.918,0,0,1.26,2.238-1.818,3.217s-9.942.742-11.611-.979S148.193,198.269,148.193,198.269Z",
    transform: "translate(19.069 -94.307)",
    fill: "url(#linear-gradient-55)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M191.739,190.915h0a.933.933,0,0,1-.929-.931V183.7a.934.934,0,0,1,.929-.931h0a.934.934,0,0,1,.931.931v6.283A.933.933,0,0,1,191.739,190.915Z",
    transform: "translate(25.038 -95.694)",
    fill: "url(#linear-gradient-56)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M197.513,190.915h0a.932.932,0,0,1-.929-.931V183.7a.933.933,0,0,1,.929-.931h0a.934.934,0,0,1,.931.931v6.283A.933.933,0,0,1,197.513,190.915Z",
    transform: "translate(25.817 -95.694)",
    fill: "url(#linear-gradient-57)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M203.288,190.915h0a.933.933,0,0,1-.931-.931V183.7a.934.934,0,0,1,.931-.931h0a.935.935,0,0,1,.931.931v6.283A.934.934,0,0,1,203.288,190.915Z",
    transform: "translate(26.596 -95.694)",
    fill: "url(#linear-gradient-58)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(107.269 141.527)"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M614.836,186.855c15.921,5.542,15.713,28.9,15.713,28.9l-30.9-28.9Z",
    transform: "translate(-26.486 -126.271)",
    fill: "url(#linear-gradient-59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(276.081 146.836)"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M468.075,329.832c0-36.988-20.947-66.975-46.787-66.975H386.636c-26.934,0-48.767,29.986-48.767,66.975,0,35.066,19.626,63.819,44.613,66.716l.145.26h38.661C447.128,396.807,468.075,366.821,468.075,329.832Z",
    transform: "translate(-337.869 -262.857)",
    fill: "url(#linear-gradient-60)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M461.614,329.26c0,34.336-19.443,62.17-43.429,62.17s-43.43-27.833-43.43-62.17,19.445-62.168,43.43-62.168S461.614,294.927,461.614,329.26Z",
    transform: "translate(-332.895 -262.286)",
    opacity: 0.3,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M450.266,326.862c0,23.189-13.131,41.985-29.329,41.985s-29.33-18.8-29.33-41.985,13.131-41.985,29.33-41.985S450.266,303.675,450.266,326.862Z",
    transform: "translate(-330.622 -259.887)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M406.933,323.939c-4.3-9.982-4.774-22.008-2.009-33.056-8.016,7.492-13.319,20.441-13.319,35.169,0,23.189,13.131,41.985,29.33,41.985,10.444,0,19.608-7.821,24.8-19.592C429.6,350.191,413.379,339.829,406.933,323.939Z",
    transform: "translate(-330.622 -259.078)",
    opacity: 0.15,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(30.565 146.836)"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M251.734,329.832c0-36.988-20.946-66.975-46.786-66.975H170.295c-26.932,0-48.767,29.986-48.767,66.975,0,35.066,19.626,63.819,44.613,66.716l.145.26h38.662C230.788,396.807,251.734,366.821,251.734,329.832Z",
    transform: "translate(-121.528 -262.857)",
    fill: "url(#linear-gradient-60)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M245.274,329.26c0,34.336-19.443,62.17-43.429,62.17s-43.43-27.833-43.43-62.17,19.443-62.168,43.43-62.168S245.274,294.927,245.274,329.26Z",
    transform: "translate(-116.553 -262.286)",
    opacity: 0.3,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M233.924,326.862c0,23.189-13.131,41.985-29.329,41.985s-29.329-18.8-29.329-41.985S188.4,284.877,204.6,284.877,233.924,303.675,233.924,326.862Z",
    transform: "translate(-114.281 -259.887)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M190.593,323.939c-4.3-9.982-4.775-22.008-2.009-33.056-8.017,7.492-13.319,20.441-13.319,35.169,0,23.189,13.131,41.985,29.329,41.985,10.445,0,19.608-7.821,24.8-19.592C213.261,350.191,197.039,339.829,190.593,323.939Z",
    transform: "translate(-114.281 -259.078)",
    opacity: 0.15,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(495.283 101.912)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M636,282.216c0-32.553-16.889-58.944-37.72-58.944H570.34c-21.716,0-39.317,26.391-39.317,58.944,0,30.861,15.822,56.167,35.968,58.717l.117.228h31.169C619.108,341.162,636,314.771,636,282.216Z",
    transform: "translate(-531.023 -223.272)",
    fill: "url(#linear-gradient-60)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M630.79,281.714c0,30.219-15.678,54.717-35.015,54.717s-35.014-24.5-35.014-54.717S576.437,227,595.776,227,630.79,251.495,630.79,281.714Z",
    transform: "translate(-527.013 -222.769)",
    opacity: 0.3,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M621.639,279.6c0,20.408-10.588,36.951-23.645,36.951s-23.648-16.543-23.648-36.951,10.588-36.951,23.648-36.951S621.639,259.2,621.639,279.6Z",
    transform: "translate(-525.181 -220.659)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M586.7,277.03c-3.464-8.785-3.847-19.369-1.617-29.092-6.464,6.595-10.739,17.99-10.739,30.952,0,20.408,10.588,36.951,23.648,36.951,8.418,0,15.807-6.883,19.995-17.243C604.978,300.133,591.9,291.016,586.7,277.03Z",
    transform: "translate(-525.181 -219.946)",
    opacity: 0.15,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M359.182,141.295c-46.663,12.634-97.82,64.539-97.82,64.539s-71.983,12.807-90.906,23.819c-21.518,12.293-45.368,40.977-45.368,40.977l-23.224,34.084v3.073s-3.63,2.319-3.63,6.416,4.127,35.734,4.127,35.734A37.084,37.084,0,0,0,100.2,361.1c-.291,7.165,14.2,16.489,19.294,17.691,1.853.437,6.57-.179,13.03.481,38.486,3.929,144.222,10.966,144.222,10.966a20.168,20.168,0,0,0,12.443,4.354c7.518,0,68.44,4.353,83.475,2.816s48.219-12.8,48.219-12.8-15.149-84.172,32.725-104.294c46.787-19.663,52.306,62.292,46.6,87.391l148.979-43.368s7.256-7.513,6.219-11.268-.412-56.33,23.506-70.345c22.726-13.318,15.207,60.1,15.207,60.1l8.557-9.647s4.235-53.527-6.136-74.015c0,0-9.161-18.952-21.6-24.587l7.518-.512s-16.849-7.939-21-8.964c0,0-50.957-52.083-120.088-51.058C541.369,134.032,423.754,130.467,359.182,141.295Z",
    transform: "translate(-94.104 -133.47)",
    fill: "#3cc4f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M344.716,377.068c16.362-3,42.925-12.018,42.925-12.018s-9.872-54.887,11.538-86.612C367.914,303.288,352.478,339.39,344.716,377.068Z",
    transform: "translate(-60.865 -113.92)",
    opacity: 0.2,
    fill: "url(#linear-gradient-69)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M465.666,252.839c-12.169,2.308-32.66,7.994-43.212,12.991,35.182-1.169,39.176,67.737,34.031,90.38l148.979-43.369s7.256-7.513,6.219-11.268-.412-56.33,23.506-70.345c22.726-13.318,15.207,60.1,15.207,60.1l8.557-9.647s2.717-34.393-1.543-58.594C657.41,206.8,535.571,239.587,465.666,252.839Z",
    transform: "translate(-50.381 -121.983)",
    opacity: 0.2,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M323.3,147.186c24.66-8.109,177.645-6.2,177.645-6.2s-20.74,53.954-28.69,62.491-39.749,9.562-50.465,11.269-175.507-.6-183.542,0-12.209-6.434-12.209-6.434l18.085-3.47S297.7,155.605,323.3,147.186Z",
    transform: "translate(-76.869 -132.482)",
    fill: "url(#linear-gradient-71)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M495,140.854c-5.337,13.541-20.28,50.577-26.751,57.526-7.951,8.538-39.751,9.561-50.466,11.269s-175.505-.6-183.542,0a12.287,12.287,0,0,1-7.109-1.617l-1.091.209s4.172,7.03,12.209,6.434,172.827,1.707,183.542,0,42.515-2.732,50.465-11.269,28.69-62.491,28.69-62.491S498.8,140.888,495,140.854Z",
    transform: "translate(-76.869 -132.474)",
    fill: "url(#linear-gradient-72)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M496.871,149.691c3.535-8.7,4.076-8.7,4.076-8.7s-152.984-1.913-177.645,6.2c-25.6,8.419-79.177,57.661-79.177,57.661l-18.085,3.47s4.172,7.032,12.209,6.434c1.573-.117,4.926-.123,16.18-.069,16.108-13.888,50.12-44.16,75.007-56.452C352.3,146.936,441.855,149.2,496.871,149.691Z",
    transform: "translate(-76.869 -132.482)",
    fill: "url(#linear-gradient-73)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M273.425,262.944l91.253-14.168-4.594,11.312a48.568,48.568,0,0,1-33.271,28.755l-79.658,19.935V288.631l11.06-20.83Z",
    transform: "translate(-74.021 -117.92)",
    opacity: 0.7,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M272.915,263.233l-15.209,4.858-2.239,4.219,2.758-.881,91.254-14.168-4.594,11.312a48.167,48.167,0,0,1-14.3,19.255,48.475,48.475,0,0,0,28.989-27.45l4.594-11.313Z",
    transform: "translate(-72.9 -117.881)",
    opacity: 0.5,
    fill: "url(#linear-gradient-75)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M140.546,257.664l-6.652-14.749-8,9.424a24.3,24.3,0,0,0-3.921,25.135l7.6,18.167Z",
    transform: "translate(-91.157 -118.711)",
    opacity: 0.7,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M133.887,247.805l5.792,12.84.86-2.981-6.653-14.749-8,9.424a24.324,24.324,0,0,0-5.671,18.205,24.362,24.362,0,0,1,5.671-13.316Z",
    transform: "translate(-91.156 -118.711)",
    opacity: 0.5,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M234.485,318.16l99.082-18.668a12.551,12.551,0,0,1,11.9,5.055l14.96,20.725a8.033,8.033,0,0,1,.266,9.035l-5.712,8.972a12.177,12.177,0,0,1-9.081,5.558l-76.088,7.541a17.032,17.032,0,0,1-16.079-7.8Z",
    transform: "translate(-75.73 -111.097)",
    opacity: 0.7,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M141.152,311.521,102.48,283.475l-.689,4.084s-3.855,2.228-2.852,8.85,3.349,33.3,3.349,33.3l16.276,8.948a8.413,8.413,0,0,0,11.665-3.759Z",
    transform: "translate(-94.032 -113.241)",
    opacity: 0.7,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M244.146,206.763S173.978,224.484,160.5,235.24a71.691,71.691,0,0,0-19.184,23.05s7.777-17.579,21.517-28.893,74.637-29.1,74.637-29.1Z",
    transform: "translate(-88.295 -124.458)",
    opacity: 0.8,
    fill: "url(#linear-gradient-80)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M444.417,203s-133.048,36.635-148.084,40.926-29.38,22.63-29.38,22.63,5.76-14.777,25.433-24.508S399.165,207,399.165,207Z",
    transform: "translate(-71.352 -124.094)",
    opacity: 0.8,
    fill: "url(#linear-gradient-81)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M455.619,210.2c9.541,21.792,10.407,88.341,10.366,114.274a8.074,8.074,0,0,0,10.23,7.72L577.578,304.85",
    transform: "translate(-45.909 -123.122)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.681,
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M552.385,190.987s10.495,15.288,12.57,27.067-.891,105.467-.891,105.467",
    transform: "translate(-32.86 -125.713)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.681,
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(149.172 8.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(30.433 -60.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M270.738,270.593l-17.881-17.867L422.416,87.113,440.3,104.981Z",
    transform: "translate(-252.857 -87.113)",
    fill: "url(#linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M334.7,286.42l-17.881-17.867L486.373,102.94l17.881,17.868Z",
    transform: "translate(-244.232 -84.978)",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M303.366,272.368,295.994,265,465.554,99.389l7.372,7.367Z",
    transform: "translate(-247.04 -85.457)",
    fill: "url(#linear-gradient-84)"
  }))))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M518.868,140.941c-43.533-8.391-51.328,28.2-54.958,37-4.462,10.816-11.925,42.423-11.925,42.423s67.413-15.081,111.366-25.21c-7.961-16.149-18.581-35.473-26.469-49.5A149.173,149.173,0,0,0,518.868,140.941Z",
    transform: "translate(-46.399 -132.63)",
    fill: "url(#linear-gradient-85)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M535.381,145.655a149.174,149.174,0,0,0-18.014-4.713c-40.948-7.892-50.276,24.008-54.26,35.146a271.615,271.615,0,0,1,36.414,33.248c20.315-4.586,43.477-9.84,62.328-14.185C553.89,179,543.27,159.678,535.381,145.655Z",
    transform: "translate(-44.899 -132.63)",
    fill: "url(#linear-gradient-86)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M533.649,145.654a149.172,149.172,0,0,0-18.014-4.713c-19.388-3.737-31.683,1.45-39.682,9.128,33.52-12.571,69.158,13.953,74.938,47.2,3.165-.725,6.251-1.434,9.227-2.12C552.157,179,541.537,159.678,533.649,145.654Z",
    transform: "translate(-43.167 -132.63)",
    fill: "url(#linear-gradient-87)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M590.5,178.9c-9.83-7.32-32.61-22.923-59.831-32.632,7.793,13.917,17.692,32.045,25.176,47.278,18.41-4.252,32.077-7.5,33.751-8.144A3.737,3.737,0,0,0,590.5,178.9Z",
    transform: "translate(-35.788 -131.744)",
    fill: "url(#linear-gradient-88)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M590.5,178.9c-9.83-7.32-32.61-22.923-59.831-32.632,1.509,2.7,3.1,5.552,4.735,8.511a82.041,82.041,0,0,1,48.967,32.031c2.848-.709,4.677-1.2,5.225-1.408A3.737,3.737,0,0,0,590.5,178.9Z",
    transform: "translate(-35.788 -131.744)",
    fill: "url(#linear-gradient-89)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M450.63,221s.1-1.28.277-2.289.481-2.466.878-4.319c.8-3.7,2.059-8.965,3.869-15.193s4.173-13.424,7.171-20.96c1.5-3.767,3.15-7.621,4.97-11.471.941-1.911,1.807-3.876,2.844-5.768l1.507-2.867c.263-.49.478-.933.781-1.462l.841-1.38a34.021,34.021,0,0,1,8.763-9.7l.646-.5.688-.436,1.366-.867c.923-.557,1.9-1.005,2.837-1.508.988-.4,1.951-.844,2.939-1.19,1-.3,1.972-.7,2.984-.919a46.418,46.418,0,0,1,11.741-1.45,65.166,65.166,0,0,1,10.533.882,88.631,88.631,0,0,1,15.251,3.969c3.584,1.279,5.548,2.214,5.548,2.214s-1.984-.891-5.59-2.09a88.518,88.518,0,0,0-15.283-3.618,64.461,64.461,0,0,0-10.451-.642,45.634,45.634,0,0,0-11.484,1.673c-.982.23-1.91.642-2.879.957-.953.357-1.872.811-2.819,1.215-.9.507-1.827.959-2.7,1.515l-1.3.864-.65.432-.611.49a24.546,24.546,0,0,0-2.376,2.047l-1.129,1.1c-.371.373-.691.794-1.038,1.188l-1.026,1.2-.907,1.278-.9,1.279-.81,1.4-.81,1.4c-.222.411-.472.94-.707,1.4l-1.429,2.872c-.983,1.9-1.8,3.862-2.686,5.774-1.716,3.852-3.265,7.7-4.664,11.467-2.8,7.526-4.977,14.7-6.626,20.9s-2.775,11.427-3.482,15.092c-.351,1.832-.6,3.273-.767,4.256l-.151.977Z",
    transform: "translate(-46.582 -132.762)",
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M141.548,256.683s6.561-13.323,18.336-22.362c3.153-2.418,234.722-22.11,234.722-22.11s-67.064,20.093-88.284,30.315-28.754,25.923-28.754,25.923-77.843,2.995-101.693,1.459-36.306-7.047-36.306-7.047Z",
    transform: "translate(-88.53 -122.851)",
    opacity: 0.4,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M390.781,213.053,167.939,233.416l78.146-27.454,166.433.642Z",
    transform: "translate(-84.704 -123.694)",
    opacity: 0.5,
    fill: "url(#linear-gradient-92)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M139.419,255.911l-10.972,37.977,10.972,17.343,106.462,8.2,17.283-11.612s8.987-35.669,26.27-45.835C289.433,261.981,158.084,270.253,139.419,255.911Z",
    transform: "translate(-90.03 -116.958)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M224.885,263.567c-23.375,26.04-59.9,39.067-94.436,33.191l8.7,13.751,106.462,8.2,17.283-11.612s8.987-35.669,26.27-45.835C289.163,261.26,258.612,263.182,224.885,263.567Z",
    transform: "translate(-89.76 -116.237)",
    opacity: 0.5,
    fill: "url(#linear-gradient-94)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M267.739,282.465s5.809-9.9,12.723-11.611,62.562-10.585,62.562-10.585-6.912,17.757-17.973,22.2-61.524,15.535-63.6,14.257S267.739,282.465,267.739,282.465Z",
    transform: "translate(-72.138 -116.37)",
    fill: "url(#linear-gradient-95)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M321.873,263.686c-11.2,20.4-35.909,26.808-59.546,28.405-1.038,2.275-1.6,4.18-.873,4.63,2.073,1.278,52.536-9.818,63.6-14.257s17.973-22.2,17.973-22.2S333.516,261.785,321.873,263.686Z",
    transform: "translate(-72.138 -116.37)",
    opacity: 0.5,
    fill: "url(#linear-gradient-95)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M137.544,264.4c.28-.97-6.429-13-6.429-13-8.3,10.067-6.881,18.5.49,33.56Z",
    transform: "translate(-90.432 -117.567)",
    fill: "url(#linear-gradient-97)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M130.569,251.4c-.228.276-.42.547-.634.822,5.922,9.759,4.226,20.234-.426,29.455.486,1.063,1,2.149,1.55,3.283L137,264.4C137.278,263.432,130.569,251.4,130.569,251.4Z",
    transform: "translate(-89.887 -117.567)",
    opacity: 0.5,
    fill: "url(#linear-gradient-98)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(38.417 141.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(-9.728 1.208)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(8.995)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M213.331,276.567c-60.911-1.032-84.256-12.882-85.53-13.554l2.273-4.215c.41.214,42.326,21.263,159.461,9.357l.495,4.751A652.273,652.273,0,0,1,213.331,276.567Z",
    transform: "translate(-127.801 -258.799)",
    fill: "url(#linear-gradient-99)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(5.997 11.755)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M210.689,286.925c-60.911-1.032-84.257-12.882-85.53-13.555l2.273-4.214c.409.213,42.324,21.263,159.46,9.357l.5,4.751A652.063,652.063,0,0,1,210.689,286.925Z",
    transform: "translate(-125.159 -269.157)",
    fill: "url(#linear-gradient-100)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(2.998 23.511)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M208.047,297.283c-60.911-1.03-84.256-12.881-85.53-13.555l2.273-4.213c.41.213,42.326,21.263,159.461,9.356l.494,4.75A652.269,652.269,0,0,1,208.047,297.283Z",
    transform: "translate(-122.517 -279.516)",
    fill: "url(#linear-gradient-101)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(0 35.266)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M205.406,307.641c-60.912-1.03-84.257-12.882-85.531-13.554l2.273-4.214c.41.214,42.326,21.263,159.461,9.356l.495,4.752A652.253,652.253,0,0,1,205.406,307.641Z",
    transform: "translate(-119.875 -289.874)",
    fill: "url(#linear-gradient-102)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(-9.693 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(8.995)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M213.362,274.761c-60.911-1.03-84.256-12.881-85.53-13.552l2.273-4.216c.41.217,42.326,21.264,159.461,9.358l.495,4.749A651.775,651.775,0,0,1,213.362,274.761Z",
    transform: "translate(-127.832 -256.993)",
    fill: "url(#linear-gradient-103)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(5.997 11.756)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M210.72,285.119c-60.911-1.029-84.257-12.881-85.53-13.554l2.273-4.214c.41.214,42.326,21.262,159.461,9.358l.495,4.749A651.745,651.745,0,0,1,210.72,285.119Z",
    transform: "translate(-125.19 -267.352)",
    fill: "url(#linear-gradient-104)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(2.998 23.511)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M208.079,295.477c-60.912-1.029-84.257-12.879-85.531-13.551l2.273-4.216c.41.214,42.327,21.264,159.461,9.357l.495,4.753A652.175,652.175,0,0,1,208.079,295.477Z",
    transform: "translate(-122.548 -277.71)",
    fill: "url(#linear-gradient-105)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(0 35.267)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M205.437,305.837c-60.912-1.032-84.257-12.882-85.531-13.555l2.273-4.214c.41.214,42.326,21.264,159.461,9.357l.495,4.751A652.281,652.281,0,0,1,205.437,305.837Z",
    transform: "translate(-119.906 -288.069)",
    fill: "url(#linear-gradient-106)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M279.637,271.43a35.119,35.119,0,0,1,9.8-9.24s-131.349,8.274-150.014-6.069L128.447,294.1l5.055,7.991,8.135-28.155A9.972,9.972,0,0,1,153.279,267C183.809,273.375,248.348,272.928,279.637,271.43Z",
    transform: "translate(-90.03 -116.93)",
    opacity: 0.8,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(79.935 157.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M198.542,288.691a15.8,15.8,0,1,1-15.8-15.611A15.705,15.705,0,0,1,198.542,288.691Z",
    transform: "translate(-164.773 -271.88)",
    opacity: 0.6,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M196.5,287.568a15.735,15.735,0,1,1-15.735-15.545A15.64,15.64,0,0,1,196.5,287.568Z",
    transform: "translate(-165.031 -272.023)",
    fill: "url(#linear-gradient-74)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M194.034,287.31A13.531,13.531,0,1,1,180.5,273.941,13.449,13.449,0,0,1,194.034,287.31Z",
    transform: "translate(-164.769 -271.764)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.908
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M263.444,314.332l58.864-10.77c4.184-.632,8.314,1.691,10.7,6.022,3.795,6.9,10.284,17.739,10.791,18.962,1.074,2.585-.4,5.438-1.9,8.364a9.62,9.62,0,0,1-7.456,5.534l-66.327,8.166a2.767,2.767,0,0,1-1.285-.185l-11.489-8.306c-2.244-.89-3.088-4.28-1.632-6.555l7.53-19.7A3.238,3.238,0,0,1,263.444,314.332Z",
    transform: "translate(-73.235 -110.546)",
    opacity: 0.7,
    fill: "url(#linear-gradient-110)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M270.982,313.315l58.864-10.767c4.184-.632,8.315,1.691,10.7,6.023,3.795,6.9,10.284,17.739,10.791,18.959,1.075,2.585-.4,5.439-1.9,8.365a9.628,9.628,0,0,1-7.457,5.536l-66.327,8.165a2.769,2.769,0,0,1-1.285-.186L262.877,341.1c-2.245-.887-3.089-4.28-1.633-6.555l7.53-19.7A3.251,3.251,0,0,1,270.982,313.315Z",
    transform: "translate(-72.219 -110.683)",
    fill: "url(#linear-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M350.917,327.529c-.507-1.22-7-12.062-10.791-18.959-2.382-4.332-6.513-6.655-10.7-6.023l-15.41,2.82c-4.3,21.829-28.007,34.159-50.4,36.574l10.328,7.467a2.769,2.769,0,0,0,1.285.186l66.327-8.165a9.628,9.628,0,0,0,7.457-5.536C350.513,332.968,351.991,330.114,350.917,327.529Z",
    transform: "translate(-71.801 -110.683)",
    opacity: 0.4,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M270.982,313.315l58.864-10.767c4.184-.632,8.315,1.691,10.7,6.023,3.795,6.9,10.284,17.739,10.791,18.959,1.075,2.585-.4,5.439-1.9,8.365a9.628,9.628,0,0,1-7.457,5.536l-66.327,8.165a2.769,2.769,0,0,1-1.285-.186L262.877,341.1c-2.245-.887-3.089-4.28-1.633-6.555l7.53-19.7A3.251,3.251,0,0,1,270.982,313.315Z",
    transform: "translate(-72.219 -110.683)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 2.725
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M130.8,327.55l-1.76-21.148a3.293,3.293,0,0,0-1.487-2.165l-20.662-13.517a3.55,3.55,0,0,0-5.178,1.623c-4.514,9.856-2.12,22.178-.036,31.609a5.418,5.418,0,0,0,2.75,3.655l8.633,4.516a2.739,2.739,0,0,0,1.21.313l12.9.276C129.487,332.761,131.364,330.092,130.8,327.55Z",
    transform: "translate(-93.981 -112.34)",
    opacity: 0.7,
    fill: "url(#linear-gradient-113)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(37.46 208.614)"
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M127.6,348.24l8.91-20.592a17.29,17.29,0,0,1,16.9-10.324l82.094,4.808a17.32,17.32,0,0,1,12.894,6.931L271.08,359.57Z",
    transform: "translate(-127.604 -317.295)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M271.08,359.193,248.4,328.686a17.323,17.323,0,0,0-12.894-6.929l-28.52-1.671c-22.133,12.256-49.194,19-74.877,17.363L127.6,347.864Z",
    transform: "translate(-127.604 -316.918)",
    opacity: 0.2,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M271.08,358.148l-22.534-30.311C211.822,345.5,168.974,351.482,129.1,343.358l-1.5,3.46Z",
    transform: "translate(-127.604 -315.873)",
    opacity: 0.2,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M159,322.447l82.094,4.807a17.393,17.393,0,0,1,8.427,2.775l-.717-.966a17.323,17.323,0,0,0-12.9-6.931l-82.094-4.808a17.288,17.288,0,0,0-16.9,10.324l-8.91,20.592,7.156.565,6.939-16.033A17.288,17.288,0,0,1,159,322.447Z",
    transform: "translate(-127.549 -317.295)",
    opacity: 0.8,
    fill: "url(#linear-gradient-117)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M127.372,325.9l-1.76-21.149a3.294,3.294,0,0,0-1.487-2.165l-20.661-13.516a3.548,3.548,0,0,0-5.178,1.623c-4.516,9.854-2.121,22.178-.036,31.608a5.412,5.412,0,0,0,2.75,3.655l8.632,4.516a2.742,2.742,0,0,0,1.21.313l12.9.276C126.059,331.107,127.935,328.437,127.372,325.9Z",
    transform: "translate(-94.444 -112.563)",
    fill: "url(#linear-gradient-118)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M127.276,324.741a37.23,37.23,0,0,1-19.395-32.787l-4.417-2.888a3.548,3.548,0,0,0-5.178,1.623c-4.516,9.854-2.121,22.178-.036,31.608a5.412,5.412,0,0,0,2.75,3.655l8.632,4.516a2.742,2.742,0,0,0,1.21.313l12.9.276c2.316.051,4.192-2.619,3.629-5.16Z",
    transform: "translate(-94.444 -112.563)",
    opacity: 0.4,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M102.837,289,123.5,302.514s1.3-.048,1.773,5.606,1.575,19.131,1.575,19.131a4.8,4.8,0,0,1-3.73,3.737c-3.136.531-12.9-.276-12.9-.276l-9.841-4.829",
    transform: "translate(-93.816 -112.496)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.816
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(243.408 200.857)"
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M334.871,323.2a11.3,11.3,0,1,1-11.3-11.16A11.23,11.23,0,0,1,334.871,323.2Z",
    transform: "translate(-308.648 -310.246)",
    fill: "url(#linear-gradient-95)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M329.461,313.557c.968,5.183-.907,8.641-4.43,12.123-4.462,3.148-7.927,3.928-11.846,1.953a11.314,11.314,0,0,0,21.563-4.638A11.109,11.109,0,0,0,329.461,313.557Z",
    transform: "translate(-308.525 -310.041)",
    opacity: 0.5,
    fill: "url(#linear-gradient-95)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M335.3,323.412a13.113,13.113,0,1,1-13.111-12.953A13.033,13.033,0,0,1,335.3,323.412Z",
    transform: "translate(-309.079 -310.459)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.99
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(0 182.599)"
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M107.49,307.112c0,6.164-2.528,11.16-5.648,11.16s-5.649-5-5.649-11.16,2.53-11.161,5.649-11.161S107.49,300.948,107.49,307.112Z",
    transform: "translate(-94.38 -294.158)",
    fill: "url(#linear-gradient-95)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M104.786,297.47a20.489,20.489,0,0,1-2.215,12.121c-2.232,3.149-3.964,3.928-5.923,1.953.891,3.847,2.852,6.523,5.133,6.523,3.12,0,5.648-5,5.648-11.16C107.429,302.927,106.373,299.445,104.786,297.47Z",
    transform: "translate(-94.318 -293.953)",
    opacity: 0.5,
    fill: "url(#linear-gradient-123)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M107.706,307.325c0,7.154-2.935,12.953-6.555,12.953s-6.556-5.8-6.556-12.953,2.935-12.954,6.556-12.954S107.706,300.17,107.706,307.325Z",
    transform: "translate(-94.595 -294.371)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.407
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M282.653,252.543S232.7,266,158.416,262.846c0,0,57.316,4.594,116.611.163Z",
    transform: "translate(-85.988 -117.412)",
    opacity: 0.5,
    fill: "url(#linear-gradient-80)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M267.237,363.7l78.658-17.1-78.347,7.611a16.082,16.082,0,0,1-13.819-7.866l-19.244-30.422,19.991,41.6A11.447,11.447,0,0,0,267.237,363.7Z",
    transform: "translate(-75.73 -108.865)",
    opacity: 0.8,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M140.734,308.188l-12.09,25.19s-5.389,4.434-9.1,2.556-17.674-9.557-17.674-9.557l22.782,23.459a4.122,4.122,0,0,0,6.965-1.911Z",
    transform: "translate(-93.614 -109.908)",
    opacity: 0.8,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M384.343,368.866s-17.52-85.634,37.356-105.95c53.234-12.886,41.971,89.046,41.971,89.046l6.06-1.762s9.747-113.089-50.792-98.811c-58.685,13.842-49.2,122.142-49.2,122.142Z",
    transform: "translate(-57.567 -117.736)",
    opacity: 0.4,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(402.881 57.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M452.5,205.674l-2.867,14.156a1.827,1.827,0,0,0,2.193,2.13l23.44-5.044s29.036-.343,39.751-.683,19.357-26.295,16.244-29.708-51.5-2.05-56.341,1.707-7.949,11.952-7.949,11.952L453.754,204.3A1.822,1.822,0,0,0,452.5,205.674Z",
    transform: "translate(-449.602 -184.568)",
    fill: "url(#linear-gradient-128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M467.174,199.412c-.126.305-.2.493-.2.493l-13.222,4.116A1.822,1.822,0,0,0,452.5,205.4l-2.867,14.156a1.828,1.828,0,0,0,2.193,2.13l23.44-5.044s29.036-.343,39.751-.683c10.376-.331,18.809-24.68,16.507-29.319C510.173,191.718,488.457,195.194,467.174,199.412Z",
    transform: "translate(-449.602 -184.289)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M528.922,187.172c-2.805-3.081-48.6-1.592-52.968,1.8-.227.176-.452.364-.671.561-4,3.594-6.615,6.559-5.984,12.708l-12.936,4.4a1.828,1.828,0,0,0-1.414,1.445l-1.627,8.761a1.825,1.825,0,0,0,2.146,2.111l30.016-5.605a47.439,47.439,0,0,0,4.67,1.311c7.851-.116,17.048-.272,21.969-.43C521.787,213.918,531.731,190.25,528.922,187.172Z",
    transform: "translate(-449.104 -184.443)",
    fill: "url(#linear-gradient-130)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M604.764,292.327l-131,29.483,130.837-34.6Z",
    transform: "translate(-43.462 -112.738)",
    opacity: 0.5,
    fill: "url(#linear-gradient-74)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M439.308,244.553l134.355-23,52.877-33.618L574.288,229.4Z",
    transform: "translate(-48.109 -126.126)",
    opacity: 0.3,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M629.477,187.306,574.2,221.633l-138.872,23Z",
    transform: "translate(-48.645 -126.21)",
    opacity: 0.6,
    fill: "url(#linear-gradient-133)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M583.723,312.345S581.235,234,611.653,223.4s23.021,60.647,23.021,60.647l-6.018,6.786s7.555-72.243-15.207-60.1c-24.953,13.311-23.506,70.345-23.506,70.345S591.174,304.67,583.723,312.345Z",
    transform: "translate(-28.64 -121.487)",
    opacity: 0.4,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(256.52 7.731)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M474.507,174.44c2.128-5.624,4.319-11.224,6.5-16.829l3.274-8.4,3.327-8.382.587.858-20.954.308-20.955.227-20.953.283-20.953.235-41.9.665q-5.238.09-10.471.247c-3.49.111-6.983.174-10.47.308s-6.98.213-10.463.447c-1.741.109-3.487.178-5.225.32l-5.214.506,5.187-.758c1.733-.238,3.477-.348,5.216-.528,3.479-.361,6.968-.573,10.454-.826,3.486-.277,6.978-.437,10.468-.612s6.983-.342,10.474-.478l10.476-.417q5.238-.194,10.478-.33l20.959-.463c6.987-.13,13.972-.278,20.96-.343l20.962-.132,20.962-.061,20.962.153.948.007-.362.852-3.513,8.307-3.569,8.287C479.311,163.41,476.939,168.937,474.507,174.44Z",
    transform: "translate(-320.633 -140.282)",
    fill: "url(#linear-gradient-135)"
  })))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M217.515,189.213l100-40.2v84.4l-100-40.264Z",
    transform: "translate(29.251 10.153)",
    fill: "url(#linear-gradient-80)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M324.71,200.917a9.887,9.887,0,0,0-11.434-9.839,14.693,14.693,0,0,0-20.895-5.4,11.208,11.208,0,0,0-19.091,1.47,17.3,17.3,0,0,0-13.958-.4,11.865,11.865,0,1,0-10.047,21.486,17.4,17.4,0,0,0,30.294,5.375,10.724,10.724,0,0,0,14.473-2.263,14.6,14.6,0,0,0,3.556,1.158,11.86,11.86,0,0,0,22.267-3.055A9.946,9.946,0,0,0,324.71,200.917Z",
    transform: "translate(32.57 14.469)",
    fill: "url(#linear-gradient-80)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M437.4,131.142a6.312,6.312,0,0,0-6.312-6.311,6.494,6.494,0,0,0-.934.076,9.309,9.309,0,0,0-13.24-3.422,7.1,7.1,0,0,0-12.1.932,10.961,10.961,0,0,0-8.845-.255,7.519,7.519,0,1,0-6.367,13.616,11.028,11.028,0,0,0,19.2,3.407,6.8,6.8,0,0,0,9.171-1.434,9.262,9.262,0,0,0,2.254.733,7.515,7.515,0,0,0,14.11-1.936A6.3,6.3,0,0,0,437.4,131.142Z",
    transform: "translate(51.847 6.043)",
    fill: "url(#linear-gradient-80)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M389.36,134.6a4.352,4.352,0,0,0-4.352-4.352,4.451,4.451,0,0,0-.645.052,6.419,6.419,0,0,0-9.131-2.359,4.9,4.9,0,0,0-8.342.642,7.556,7.556,0,0,0-6.1-.176,5.184,5.184,0,1,0-4.39,9.389,7.605,7.605,0,0,0,13.238,2.349,4.689,4.689,0,0,0,6.325-.988,6.385,6.385,0,0,0,1.554.505,5.182,5.182,0,0,0,9.729-1.335A4.345,4.345,0,0,0,389.36,134.6Z",
    transform: "translate(47.558 7.037)",
    fill: "url(#linear-gradient-80)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M410,173.577a13.517,13.517,0,0,0-2,.165,20.061,20.061,0,0,0-9.149-8.629A15.545,15.545,0,0,0,382,143.955a23.052,23.052,0,0,0-32.788-8.475,17.588,17.588,0,0,0-29.957,2.306,27.136,27.136,0,0,0-21.9-.63,18.6,18.6,0,0,0-27,16.62,18.8,18.8,0,0,0,.174,2.48,15.464,15.464,0,0,0-1.741,2.67,23.479,23.479,0,0,0-18.949-.544A16.106,16.106,0,1,0,236.2,187.55a23.625,23.625,0,0,0,41.124,7.3,14.561,14.561,0,0,0,19.647-3.072,19.8,19.8,0,0,0,4.827,1.57,16.072,16.072,0,0,0,20.98,7.522,23.607,23.607,0,0,0,39.484,3.46,14.565,14.565,0,0,0,19.648-3.072,19.764,19.764,0,0,0,4.825,1.57,16.1,16.1,0,0,0,30.227-4.147,13.511,13.511,0,0,0-6.957-25.1Z",
    transform: "translate(30.459 7.342)",
    fill: "url(#linear-gradient-80)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M224.449,207.059a3.769,3.769,0,1,1-3.769-3.769A3.769,3.769,0,0,1,224.449,207.059Z",
    transform: "translate(29.169 17.473)",
    fill: "url(#linear-gradient-141)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M220.839,129.817a12.37,12.37,0,1,1-12.371-12.37A12.371,12.371,0,0,1,220.839,129.817Z",
    transform: "translate(26.363 5.897)",
    fill: "url(#linear-gradient-142)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M246.235,132.09a6.185,6.185,0,1,1-6.185-6.186A6.185,6.185,0,0,1,246.235,132.09Z",
    transform: "translate(31.456 7.037)",
    fill: "url(#linear-gradient-143)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M420.35,100.622a10.79,10.79,0,1,1-10.79-10.789A10.79,10.79,0,0,1,420.35,100.622Z",
    transform: "translate(53.694 2.173)",
    fill: "url(#linear-gradient-144)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M450.962,123.25a6.853,6.853,0,1,1-6.852-6.855A6.853,6.853,0,0,1,450.962,123.25Z",
    transform: "translate(58.884 5.755)",
    fill: "url(#linear-gradient-145)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 10.363,
    cy: 10.363,
    r: 10.363,
    transform: "translate(201.851 174.716) rotate(-49.179)",
    fill: "url(#linear-gradient-146)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M189.937,158.565a5.181,5.181,0,1,1-5.181-5.182A5.18,5.18,0,0,1,189.937,158.565Z",
    transform: "translate(24.134 10.743)",
    fill: "url(#linear-gradient-147)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M157.959,115.674a5.182,5.182,0,1,1-5.182-5.183A5.182,5.182,0,0,1,157.959,115.674Z",
    transform: "translate(19.822 4.959)",
    fill: "url(#linear-gradient-148)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M244.874,214.57a2.779,2.779,0,1,1-2.779-2.78A2.779,2.779,0,0,1,244.874,214.57Z",
    transform: "translate(32.191 18.619)",
    fill: "url(#linear-gradient-145)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M255.7,201.741c-.062,0-.124.008-.187.01a5.767,5.767,0,0,0-9.68-2.706,11.986,11.986,0,0,0-19.913,9c0,.3.023.586.044.876l-.044,0a6.91,6.91,0,1,0,6.32,9.7,11.963,11.963,0,0,0,14.94-2.973,9.565,9.565,0,1,0,8.52-13.905Z",
    transform: "translate(29.452 16.497)",
    fill: "url(#linear-gradient-150)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M212.371,208.092c-.1,0-.187.014-.281.015a8.72,8.72,0,0,0-14.636-4.088,18.118,18.118,0,0,0-30.1,13.609c0,.447.035.885.067,1.323-.023,0-.044,0-.067,0a10.446,10.446,0,1,0,9.554,14.66,18.087,18.087,0,0,0,22.587-4.5,14.459,14.459,0,1,0,12.879-21.021Z",
    transform: "translate(21.077 16.96)",
    fill: "url(#linear-gradient-150)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M205.781,230.691a9.827,9.827,0,1,1-9.827-9.828A9.827,9.827,0,0,1,205.781,230.691Z",
    transform: "translate(25.018 19.843)",
    fill: "url(#linear-gradient-152)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M154.15,243.5c-2.917,6.2-8.164,18.223-1.614,20s7.34-18.177,13.089-18.256,1.591,5.779,6.236,8.115-.109-6.3,8.711-6.982-4.2,26.468,4.536,30.87,6.588-28.824,14.963-31.866,4.757,11.772,14.7,11.922,5.7-19.373,21.611-16.3l-1.127-19.186-54.819-4.548S161.119,228.689,154.15,243.5Z",
    transform: "translate(20.063 19.358)",
    fill: "url(#linear-gradient-153)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M256.57,241.835c-2.918,6.2-4.813,8.757,1.737,10.533s13.319-12.121,18.144-10.779,3.175,7.887,12.735,9.945c8.518,1.832,8.791-8.134,13.305-7.817s.293,15.834,10.232,15.982,10.163-23.434,26.074-20.358l-1.127-19.186-54.818-4.55S263.539,227.026,256.57,241.835Z",
    transform: "translate(34.156 19.134)",
    fill: "url(#linear-gradient-154)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(966.582 213.173)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 91.661,
    cy: 19.351,
    rx: 91.661,
    ry: 19.351,
    transform: "translate(326.929 481.834)",
    opacity: 0.55,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 91.661,
    cy: 19.351,
    rx: 91.661,
    ry: 19.351,
    transform: "translate(542.371 484.034)",
    opacity: 0.55,
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(361.767 88.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(0 4.111)"
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M445.474,190.53c1.772,11.532,3.171,49.59,4.59,58.358s8.036,38.075,8.036,38.075H442.692s-9.645-46.726-10.119-66.51-3.962-27.923-3.962-27.923Z",
    transform: "translate(-351.601 -82.87)",
    fill: "url(#linear-gradient-155)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M445.474,190.53l-16.863,2s3.488,8.14,3.962,27.923a197.71,197.71,0,0,0,2.082,20.91,60.933,60.933,0,0,1,12.554-31.432C446.665,201.815,446.091,194.556,445.474,190.53Z",
    transform: "translate(-351.601 -82.87)",
    opacity: 0.4,
    fill: "url(#linear-gradient-156)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(72.07 164.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M493.449,286l-58.034,13.915a1.044,1.044,0,0,1-1.256-.771L424.149,257.4a1.047,1.047,0,0,1,.772-1.256l58.034-13.915a1.044,1.044,0,0,1,1.256.77l10.009,41.743A1.046,1.046,0,0,1,493.449,286Z",
    transform: "translate(-424.12 -242.203)",
    fill: "url(#linear-gradient-157)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M492.072,285.383l-55.884,13.4a1.044,1.044,0,0,1-1.256-.771L425.3,257.833a1.043,1.043,0,0,1,.771-1.255l55.882-13.4a1.045,1.045,0,0,1,1.257.771l9.631,40.176A1.045,1.045,0,0,1,492.072,285.383Z",
    transform: "translate(-424.006 -242.108)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M489.715,270.337c-16.283,2.4-33.88-5.458-42.327-19.628l-21.17,5.076a1.2,1.2,0,0,0-.885,1.443l9.56,39.874a1.2,1.2,0,0,0,1.443.884l55.581-13.326a1.2,1.2,0,0,0,.885-1.444Z",
    transform: "translate(-424.003 -241.352)",
    opacity: 0.15,
    fill: "url(#linear-gradient-25)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M481.015,256.241l-1.315.471a.552.552,0,0,0-.346.65l2.087,8.262a.548.548,0,0,0,.7.388l1.345-.425a.545.545,0,0,0,.365-.657l-2.115-8.309A.549.549,0,0,0,481.015,256.241Z",
    transform: "translate(-418.6 -240.802)",
    fill: "url(#linear-gradient-159)"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M459.329,289.444a5.282,5.282,0,0,1-.727,5.329c-1.769,2.121-9.111,4.311-12.269,3.934s-3.489-3.657-4.121-5.05-.553-7.064,4.565-8.344c4.575-1.143,6.588,2.168,8.958,3.963C456.7,290.008,459.329,289.444,459.329,289.444Z",
    transform: "translate(-350.269 -73.417)",
    fill: "url(#linear-gradient-160)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M458.6,202.9s-5.555-29.2-16.067-39.384c-3.017-2.924-11.125-4.024-14.784-4.2v0a15.735,15.735,0,0,0-4.722-.5l-3.621.169L395.995,155.2c-5.125,3.018-24.678,5.765-29.149,14.217s-3.544,37.9-3.544,37.9c7.883,5.816,20.787,1.636,20.787,1.636l.376,51.453c40.678,15.172,60.208-2.126,60.208-2.126s-1.323-40.715-3.4-67.455l.856,15.326S443.856,204.91,458.6,202.9Z",
    transform: "translate(-358.139 -86.402)",
    fill: "url(#linear-gradient-161)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M440.518,201.732l-4.058-9.526s-4.806-10.566-7.571-16.669c0,0,2.44,17.429,3.475,24.344-20.781-6.1-39.122-22.24-46.345-42.036-1.98.561-4.069,1.18-6.088,1.936,5.641,16.338,3.687,34.129-2.241,49.268,2.2.238,3.643.271,3.643.271l1.686,50.823c40.678,15.172,60.208-2.126,60.208-2.126s-1-30.681-2.622-56.269Z",
    transform: "translate(-356.693 -86.138)",
    opacity: 0.4,
    fill: "url(#linear-gradient-162)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M392.7,136.549c2.124,6.143-1.6,21.892-1.6,21.892,7.921,9.618,20.434,9.017,25.712,4.157-.922-3.6,2.589-17.247,2.589-17.247l-22.875-11.828Z",
    transform: "translate(-355.352 -88.57)",
    fill: "url(#linear-gradient-163)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M419.255,145.351,396.38,133.523l-3.821,3.026a18.523,18.523,0,0,1,.641,6.107c4.39,8.681,8.245,19.705,16.754,23.069a13.616,13.616,0,0,0,6.712-3.127C415.744,158.994,419.255,145.351,419.255,145.351Z",
    transform: "translate(-355.206 -88.57)",
    opacity: 0.4,
    fill: "url(#linear-gradient-164)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(27.224)"
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M438.563,116.581c4.592,5.044-15.477,4.021-15.477,4.021l5.566-8.116A13.189,13.189,0,0,1,438.563,116.581Z",
    transform: "translate(-379.378 -90.674)",
    fill: "url(#linear-gradient-165)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M438.563,116.581c4.592,5.044-15.477,4.021-15.477,4.021l5.566-8.116A13.189,13.189,0,0,1,438.563,116.581Z",
    transform: "translate(-379.378 -90.674)",
    fill: "url(#linear-gradient-165)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M386.9,128.191c1.659-2.2,4.849-.924,6.085-.07-.826-5.423-1.33-9.3-1.33-9.3s.39-15.919,19.245-17.042c17.47-1.041,20.682,6.084,21.443,18.347,0,0-.981,22.222-1.8,25.359s-7.545,12.153-13.983,12.553-17.77-6.7-19.69-10.521a22.171,22.171,0,0,1-1.352-4.784C389.608,143.228,384.047,131.985,386.9,128.191Z",
    transform: "translate(-383.073 -91.753)",
    fill: "url(#linear-gradient-167)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M400.32,104.426a17.969,17.969,0,0,0-8.661,14.12s.5,3.876,1.33,9.3c-1.236-.854-4.427-2.133-6.085.07-2.857,3.794,2.7,15.038,8.624,14.542a22.17,22.17,0,0,0,1.352,4.784c1.919,3.819,13.251,10.921,19.69,10.521a10.046,10.046,0,0,0,3.556-.981C400.871,161.108,392.455,122.974,400.32,104.426Z",
    transform: "translate(-383.073 -91.479)",
    opacity: 0.3,
    fill: "url(#linear-gradient-168)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M401.9,116.547c1.017,8.046-5.764,15.543-5.808,17.614s-3.033-7.192-3.033-7.192-4.184-1.871-6.085.07c0,0-3.391-7.362-.209-12.093S401.9,116.547,401.9,116.547Z",
    transform: "translate(-383.145 -90.602)",
    fill: "url(#linear-gradient-169)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M410.055,112.976c7.809,9.062,20.857,8,20.857,8s1.355-7-3.232-11.278S410.055,112.976,410.055,112.976Z",
    transform: "translate(-380.681 -91.083)",
    fill: "url(#linear-gradient-170)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M430.829,108.794s-5.079-12.309-6.3-13.383-12.846-3.113-19.492-2.7-16.563,8.391-20.261,13.221.93,18.117.93,18.117l4.151-1.639Z",
    transform: "translate(-383.351 -92.656)",
    fill: "url(#linear-gradient-171)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M392.348,98.179a42.135,42.135,0,0,0-7.566,7.2c-3.695,4.831.93,18.117.93,18.117l4.151-1.639,36.321-12.071C413.1,110.047,399.533,107.643,392.348,98.179Z",
    transform: "translate(-383.351 -92.103)",
    opacity: 0.3,
    fill: "url(#linear-gradient-172)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M442.088,117.309c-11.5-8.243-28.948,7.076-39.561,5.677s-14.7-1.2-14.7-1.2,4.966-11.079,20.3-15.017,22.247.775,22.247.775Z",
    transform: "translate(-382.903 -91.402)",
    fill: "url(#linear-gradient-173)"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M448.726,274.081h0c-1.454-14.156-3.113-27.444-3.113-27.444l-.22-34.941c-13.042-6.324-18.087-53.094-18.087-53.094l-6.218-.564c3.249,10.2,4.663,32.615,4.663,32.615-15.391,4.879-26.365,1.619-26.365,1.619-.529-14.413-8.211-36.107-8.211-36.107l-7.156,2.271c8.948,21.558,10.2,60.51-5.32,65.382l4.608,26.688s-2.109,7.756-4.146,18.018l-.2-.018c-5.541,20.917-7.623,80.038-10.065,102.016s-6.245,62.577-6.245,62.577c9.5,12.386,33.741,9.849,33.741,9.849l15.836-90.471,2.713,90.471c16.66,5.288,33.788,0,33.788,0S456.245,324.08,448.726,274.081Z",
    transform: "translate(-358.196 -86.306)",
    fill: "url(#linear-gradient-174)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M377.184,401.578c-7.09-35.452-1.595-66.794,11.168-100.83,5.672-15.6-2.127-31.366,2.126-46.964,2.837-9.928,7.091-19.855,5.674-29.781-2.531-9.281-4.062-18.561-5.78-27.842-.885,11.794-4.47,21.4-11.674,23.657l4.608,26.688s-2.109,7.756-4.146,18.018l-.2-.018c-5.541,20.917-7.623,80.038-10.065,102.016s-6.245,62.577-6.245,62.577c9.5,12.386,33.741,9.849,33.741,9.849l4.961-30.193C386.579,418.24,378.413,407.721,377.184,401.578Z",
    transform: "translate(-358.196 -82.307)",
    opacity: 0.4,
    fill: "url(#linear-gradient-37)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M407.719,339.535c4.844-24.143,10.162-53.924,10.162-53.924a105.565,105.565,0,0,1,0,20.208c-1.064,11.347-2.836,14.893-3.19,28.009s.635,43.349.709,59.694c.118,26.234,29.38,26.27,29.38,26.27l-.561,10.216s-16.236,6.084-33.788,0Z",
    transform: "translate(-353.69 -73.364)",
    opacity: 0.4,
    fill: "url(#linear-gradient-176)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M390.528,229.62s35.846,1.29,48.292-3c0,0,2.256,35.248-22.873,37.24C390.706,265.861,390.528,229.62,390.528,229.62Z",
    transform: "translate(-355.409 -79.262)",
    opacity: 0.35,
    fill: "url(#linear-gradient-177)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(53.441 333.861)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M448,398.1s-27.44,4.635-40.817-1.932c0,0,3.088,30.133,3.431,39.791s-3.431,27.16,3.429,32.451c8.18,6.306,30.7,6.61,41.336,5.064s25.839-2.958,22.635-16.272c-3.3-13.714-31.212-5.179-34.416-18.244C440.519,426.4,448,398.1,448,398.1Z",
    transform: "translate(-407.185 -396.171)",
    fill: "url(#linear-gradient-178)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M421.48,453.694c-4.255-7.09,4.255-15.6-1.418-25.526-3.926-7.853,6.627-18.12,3.825-28.573-6.1-.277-12.2-1.214-16.7-3.424,0,0,3.088,30.133,3.431,39.791s-3.431,27.16,3.429,32.451c8.18,6.306,30.7,6.61,41.336,5.064,8.826-1.283,20.794-2.482,22.776-10.465C470.17,475.2,433.067,471.72,421.48,453.694Z",
    transform: "translate(-407.185 -396.171)",
    opacity: 0.2,
    fill: "url(#linear-gradient-179)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(0 332.667)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M402.554,401.194s-27.771,1.8-40.4-6.108c0,0-.02,30.29-.669,39.935s-6.2,26.665.085,32.632c7.49,7.111,29.863,9.722,40.6,9.274s26.008-.293,24.185-13.864c-1.879-13.981-30.517-8.352-32.365-21.678C392.209,428.57,402.554,401.194,402.554,401.194Z",
    transform: "translate(-358.601 -395.086)",
    fill: "url(#linear-gradient-180)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M370.472,453.774c-3.506-7.49,5.831-15.083,1.206-25.538-3.1-8.213,8.451-17.346,6.736-28.031-6.046-.9-12.012-2.458-16.263-5.119,0,0-.02,30.29-.669,39.935s-6.2,26.665.085,32.632c7.49,7.111,29.863,9.722,40.6,9.274,8.912-.372,20.939-.334,23.73-8.073C416.7,480.162,380.15,472.891,370.472,453.774Z",
    transform: "translate(-358.601 -395.086)",
    opacity: 0.2,
    fill: "url(#linear-gradient-181)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(6.829 119.903)"
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M500.121,226.63c-1.114-1.339-6.841,1.285-10.669,1.508s-11.1-2.689-11.1-3.583,5.723-2.736,4.942-4.188-6.142-.619-10.051,1.056-5.763,7.05-11.215,7.362v0c-23.607-6.445-63.787-10.4-69.68-7.048l-4.607-20.082s-15.992,5.252-22.928,1.914c0,0,3.4,26.86,8.769,32.915,6.968,7.858,67.664,3.909,87.713,3.084,2.671.744,18.97,5.449,23.9,2.525,5.359-3.182,8.4-10.527,8.4-10.527C496.1,230.4,501.239,227.97,500.121,226.63Z",
    transform: "translate(-364.809 -201.66)",
    fill: "url(#linear-gradient-182)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M388.7,206.5l-.96-4.839s-15.992,5.252-22.928,1.914a144,144,0,0,0,3.714,21.387A31.765,31.765,0,0,1,388.7,206.5Z",
    transform: "translate(-364.809 -201.66)",
    opacity: 0.4,
    fill: "url(#linear-gradient-183)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(131.212)"
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M581.342,442.405c-1.2,10.8-25.208,18.007-28.009,20.408s-5.8,6.5-2.5,8.3,36.314,0,36.314,0l4.2-6.3,3,7.1h7.517c2.686-14.9-4.817-30.81-4.817-30.81Z",
    transform: "translate(-470.739 -53.707)",
    fill: "url(#linear-gradient-184)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M640.419,439.15c.529,10.857-22.031,21.778-24.415,24.593s-4.7,7.34-1.152,8.594,35.852-5.764,35.852-5.764l3.149-6.889,4.089,6.536,7.423-1.194c.286-15.142-9.647-29.654-9.647-29.654Z",
    transform: "translate(-464.376 -54.28)",
    fill: "url(#linear-gradient-185)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M566.841,264.456C564.952,278.75,575.347,462,575.347,462c16.944,7.145,26.008,0,26.008,0l2.654-150.87s31.376,145.654,35.867,148.727c3.627,2.484,23.047-5.137,23.047-5.137.669-28.136-10.366-87.761-10.845-100.492s-1.7-73.693-12.023-88.458S566.841,264.456,566.841,264.456Z",
    transform: "translate(-469.017 -71.928)",
    fill: "url(#linear-gradient-186)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M596.558,293.182c2.679,10.72,2.679,20.6,1.339,31.32-1.339,6.7-2.68,12.9-2.68,19.6-5.3,38.407,10.327,81.854-7.426,117.645,7.517-.078,11.446-3.175,11.446-3.175l2.654-150.87A92.523,92.523,0,0,0,596.558,293.182Z",
    transform: "translate(-466.899 -68.496)",
    opacity: 0.4,
    fill: "url(#linear-gradient-187)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M648.706,354.23c-.478-12.728-1.7-73.693-12.023-88.458-4.743-6.785-20.594-7.609-36.34-6.52.289,3.892,2.007,7.594,3,10.564,6.7,10.719,24.844,17.314,27.525,28.033,14.614,51.816,27.218,143.921,21.913,159.511,3.8-1.333,6.771-2.639,6.771-2.639C660.219,426.585,649.184,366.961,648.706,354.23Z",
    transform: "translate(-465.644 -71.928)",
    opacity: 0.4,
    fill: "url(#linear-gradient-188)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(110.97 241.436)"
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    d: "M2.338,0H34.509a2.337,2.337,0,0,1,2.337,2.337V18.766A2.338,2.338,0,0,1,34.508,21.1H2.337A2.337,2.337,0,0,1,0,18.767V2.338A2.338,2.338,0,0,1,2.338,0Z",
    transform: "translate(25.388)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 3.654
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(0 12.393)"
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    d: "M2.337,0h84a2.337,2.337,0,0,1,2.337,2.337v51.6a2.338,2.338,0,0,1-2.338,2.338h-84A2.337,2.337,0,0,1,0,53.939V2.337A2.337,2.337,0,0,1,2.337,0Z",
    transform: "translate(1.351 1.676)",
    fill: "url(#linear-gradient-189)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    d: "M2.337,0h.684A2.338,2.338,0,0,1,5.359,2.338v51.6a2.338,2.338,0,0,1-2.338,2.338H2.337A2.337,2.337,0,0,1,0,53.939V2.337A2.337,2.337,0,0,1,2.337,0Z",
    transform: "translate(84.665 1.676)",
    opacity: 0.4,
    fill: "url(#linear-gradient-190)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    d: "M2.337,0H87.253A2.337,2.337,0,0,1,89.59,2.337V21.978a2.338,2.338,0,0,1-2.338,2.338H2.337A2.337,2.337,0,0,1,0,21.979V2.337A2.337,2.337,0,0,1,2.337,0Z",
    transform: "translate(0.893 1.582)",
    opacity: 0.4,
    fill: "url(#linear-gradient-191)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 91.376,
    height: 24.801,
    rx: 2.337,
    fill: "url(#linear-gradient-192)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    d: "M2.337,0h2.75A2.338,2.338,0,0,1,7.425,2.338V22.463A2.338,2.338,0,0,1,5.087,24.8H2.337A2.337,2.337,0,0,1,0,22.464V2.337A2.337,2.337,0,0,1,2.337,0Z",
    transform: "translate(83.951)",
    opacity: 0.2,
    fill: "url(#linear-gradient-193)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    d: "M2.337,0h8.684a2.337,2.337,0,0,1,2.337,2.337V4.362A2.338,2.338,0,0,1,11.02,6.7H2.338A2.338,2.338,0,0,1,0,4.362V2.337A2.337,2.337,0,0,1,2.337,0Z",
    transform: "translate(34.795 22.109)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.218
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M640.5,266.485c-.149-.235-.289-.5-.441-.713-10.321-14.763-73.215-1.316-73.215-1.316a90.573,90.573,0,0,0-.212,9.562C592.062,282.76,618.039,278.7,640.5,266.485Z",
    transform: "translate(-469.016 -71.928)",
    fill: "url(#linear-gradient-194)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M617.912,292.388s-7.335,12.253-7.892,13.368-.782,4.467.448,4.69c0,0-.113,3.909.781,5.47s12.059,4.915,16.747,0-.565-7.815-.565-7.815,3.274-7.164.782-13.194S617.912,292.388,617.912,292.388Z",
    transform: "translate(-464.722 -68.677)",
    fill: "url(#linear-gradient-35)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M509.9,225.548c-1.631.832-8.207-1.341-11.892-1.341s-7.87,1.921-7.369,3.222,7.573.416,8.039,1.133c.616.949-9.138,6.262-10.551,7.033-2.762,1.508-10.719,3.6-10.216,5.947s15.983-4.438,15.983-4.438a41.362,41.362,0,0,1-5.712,4.932c-2.679,1.768-7.814,3.331-8.036,6.458s8.82,3.8,16.524,1.227,18.089-10.941,18.089-10.941Z",
    transform: "translate(-477.887 -75.392)",
    fill: "url(#linear-gradient-35)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M614.643,290.01l-1.7,4.858c6.137,5.863,18.95,4.438,18.95,4.438l2.177-6.2Z",
    transform: "translate(-464.384 -68.813)",
    fill: "#fff"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M510.431,222.485l-6.362,2.1a25.691,25.691,0,0,1,6.362,18.593l6.2-2.012S516.63,228.594,510.431,222.485Z",
    transform: "translate(-475.27 -75.564)",
    fill: "#fff"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M572.7,163.876c-11.115,8.282-18.194,46.342-22.363,50.656,0,0-2.2-1.011-2.431,2.115l-41.682,11.2c8.336,4.168,8.336,21.187,8.336,21.187s34.735-6.946,46.2-12.156,20.031-37.166,20.031-37.166Z",
    transform: "translate(-475.054 -81.424)",
    fill: "url(#linear-gradient-197)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M569.3,163.876a12.513,12.513,0,0,0-1.159,1c-2.165,26.56-5.963,62.474-27.989,77.51,6.895-1.811,13.362-3.754,17.207-5.5,11.463-5.211,20.031-37.166,20.031-37.166Z",
    transform: "translate(-471.662 -81.424)",
    opacity: 0.3,
    fill: "url(#linear-gradient-198)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M590.538,160.894h-9.151l-6.481,20.488-2.01,92.933s7.377,15.81,38.862,2.718c0,0,3.049-74.921,2.192-78.557s1.122-43.643,1.122-43.643Z",
    transform: "translate(-468.388 -82.328)",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(112.365 78.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M587.815,166.911l-7.442,23.546s-1.6,36.276,2.2,53.472c0-12.73,13.106-53.7,13.106-53.7l-4.62-23.318Z",
    transform: "translate(-580.039 -159.208)",
    fill: "url(#linear-gradient-199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M587.653,160.257l-2.636,3.831a.943.943,0,0,0-.115.822l1.3,3.973a.791.791,0,0,0,.961.547,5.019,5.019,0,0,1,3.332.089.687.687,0,0,0,.824-.3l3.08-4.795a.939.939,0,0,0-.059-1.089l-2.546-3.111a.774.774,0,0,0-.591-.292l-2.9-.025A.783.783,0,0,0,587.653,160.257Z",
    transform: "translate(-579.557 -159.908)",
    fill: "url(#linear-gradient-200)"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M584.683,156.659c-7.036,22.11-1.342,124.039-4.356,131.694s-21.1.623-21.436-1.388,10.577-25.372,10.718-45.222-2.352-74.228-2.352-76.684S584.683,156.659,584.683,156.659Z",
    transform: "translate(-469.789 -82.145)",
    fill: "url(#linear-gradient-201)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M608.744,149.351s-21.769,49.8-23.864,69.452,6.842,68.806,21.131,74.153,42.875-2.169,44.215-7.566-21.367-36.429-19.652-56.736,5.578-66.713,5.578-66.713Z",
    transform: "translate(-467.221 -82.876)",
    fill: "url(#linear-gradient-202)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M629.019,226.559c1.2-14.257,3.465-41.359,4.706-56.254-17.732,21.187-13.644,50.156-13.644,77.081,0,1.34-4.02,5.36-4.02,6.7,2.1,14.709-3.215,30.237-15.943,33.674a11.972,11.972,0,0,0,4.339,3.1c14.291,5.347,42.875-2.169,44.215-7.566S627.3,246.866,629.019,226.559Z",
    transform: "translate(-465.667 -80.781)",
    opacity: 0.4,
    fill: "url(#linear-gradient-203)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M606.386,131.681c-2.034,5.885,1.538,20.969,1.538,20.969-4.822,5.856-18.177,10.371-18.177,10.371s-4.609-4.691-6.454-6.389c.883-3.453-2.48-16.519-2.48-16.519l21.913-11.332Z",
    transform: "translate(-467.597 -84.933)",
    fill: "url(#linear-gradient-204)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M580.813,140.112l21.913-11.332,3.661,2.9a17.767,17.767,0,0,0-.615,5.849c-4.205,8.316-8.845,21.285-16.994,24.508,0,0-3.9-3.95-5.485-5.405C584.177,153.179,580.813,140.112,580.813,140.112Z",
    transform: "translate(-467.597 -84.933)",
    opacity: 0.7,
    fill: "url(#linear-gradient-205)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M615.876,123.5c-1.734-2.3-5.068-.964-6.359-.073.864-5.667,1.388-9.716,1.388-9.716S610.5,97.073,590.8,95.9c-18.255-1.087-21.611,6.359-22.408,19.173,0,0,2.84,22.774,3.692,26.052s6.07,13.148,12.8,13.565,18.57-7,20.575-11a23.126,23.126,0,0,0,1.412-5C613.05,139.213,618.86,127.462,615.876,123.5Z",
    transform: "translate(-468.839 -88.231)",
    fill: "url(#linear-gradient-206)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M600.7,98.666c8.8,5.12,9.05,14.756,9.05,14.756s-.525,4.049-1.388,9.716c1.291-.891,4.625-2.227,6.359.073,2.984,3.964-2.826,15.715-9.012,15.2a23.13,23.13,0,0,1-1.412,5c-2.005,3.992-13.847,11.412-20.575,11A10.474,10.474,0,0,1,580,153.375C600.12,157.9,608.915,118.048,600.7,98.666Z",
    transform: "translate(-467.678 -87.943)",
    opacity: 0.3,
    fill: "url(#linear-gradient-207)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M611.671,99.641C610,89.313,595.368,86.024,582.1,91.627s-14.128,16.932-20.7,15.591c7.186,22.657,37.151.122,39.588,6-1.064,8.407,6.021,16.24,6.066,18.406s3.17-7.516,3.17-7.516,4.374-1.954,6.359.073a20.9,20.9,0,0,0,1.578-6.127h.065C620.547,103.417,611.671,99.641,611.671,99.641Z",
    transform: "translate(-469.539 -88.918)",
    fill: "url(#linear-gradient-208)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M633.314,160.8c17.865,6.725,21.326,60.742,24.34,70.791s-22.467,76.517-22.467,76.517c-13.846,3.952-22.244-4.152-22.244-4.152s19.029-66.334,18.583-68.345a6.313,6.313,0,0,1,.446-3.8l-8.932-30.369S618.63,177.826,633.314,160.8Z",
    transform: "translate(-464.384 -81.732)",
    fill: "url(#linear-gradient-209)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M613.313,151.439s-3.715,35.737-4.55,38.919-10.386,4.856-10.386,4.856,4.859,10.312,4.188,12.694-17.422,11.189-17.42,28.307c0,0-4.238-14.939,6.646-43.477s16.977-43.388,16.977-43.388Z",
    transform: "translate(-467.245 -82.876)",
    fill: "url(#linear-gradient-210)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M583.6,156.659s-5.77,43.692-3.643,77.523c0,0-7.584-28.716-7.921-31.025s4.019-7.668,4.019-10.012-5.863-1.675-6.364-4.522,9.883-31.964,9.883-31.964Z",
    transform: "translate(-468.71 -82.145)",
    fill: "url(#linear-gradient-211)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M588.935,161.161l9.716,9.714L609.975,150.3a1.435,1.435,0,0,0-.826-2.061l-2.754-.87.717,3.42Z",
    transform: "translate(-466.785 -83.074)",
    fill: "#fff"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M589.752,160.72l-7.56,8.371-1.41-13.954a2.728,2.728,0,0,1,1.389-2.659l1.243-.693a9.457,9.457,0,0,1-.115,2.546Z",
    transform: "translate(-467.601 -82.633)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingcar);
export default __webpack_public_path__ + "static/media/pricingcar.6f9e58269122477b1d384241d6d7c567.svg";
export { ForwardRef as ReactComponent };